window.TPLPromptGeneratorData = {
  "modes": [
    {
      "id": "quick",
      "label": "Quick",
      "description": "one clear idea"
    },
    {
      "id": "full",
      "label": "Full chaos",
      "description": "structured challenge"
    },
    {
      "id": "cozy",
      "label": "Cozy",
      "description": "small scenes"
    },
    {
      "id": "weird",
      "label": "Weird",
      "description": "strange but drawable"
    },
    {
      "id": "pattern",
      "label": "Pattern",
      "description": "motifs & repeats"
    },
    {
      "id": "character",
      "label": "Character",
      "description": "little roles"
    }
  ],
  "palettes": [
    {
      "name": "coral, cream, olive",
      "colors": [
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "olive",
          "hex": "#7E8F55"
        }
      ]
    },
    {
      "name": "plum, peach, linen",
      "colors": [
        {
          "name": "plum",
          "hex": "#7E4A78"
        },
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "pine, blush, ivory",
      "colors": [
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "ivory",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "slate, buttercream, cherry",
      "colors": [
        {
          "name": "slate",
          "hex": "#667085"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        }
      ]
    },
    {
      "name": "moss, papaya, porcelain",
      "colors": [
        {
          "name": "moss",
          "hex": "#6F7F4F"
        },
        {
          "name": "papaya",
          "hex": "#F49B55"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "lavender, ink, honey",
      "colors": [
        {
          "name": "lavender",
          "hex": "#C9B6E4"
        },
        {
          "name": "ink",
          "hex": "#2B2B2B"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        }
      ]
    },
    {
      "name": "berry, oat, cream",
      "colors": [
        {
          "name": "berry",
          "hex": "#A83B68"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "cobalt, cream, rust",
      "colors": [
        {
          "name": "cobalt",
          "hex": "#2957A4"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        }
      ]
    },
    {
      "name": "sage, apricot, charcoal",
      "colors": [
        {
          "name": "sage",
          "hex": "#A9B98F"
        },
        {
          "name": "apricot",
          "hex": "#F6B26B"
        },
        {
          "name": "charcoal",
          "hex": "#2B2B2B"
        }
      ]
    },
    {
      "name": "sea blue, buttercream, clay",
      "colors": [
        {
          "name": "sea blue",
          "hex": "#4AA3C7"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "clay",
          "hex": "#B96A50"
        }
      ]
    },
    {
      "name": "denim, buttercream, terracotta",
      "colors": [
        {
          "name": "denim",
          "hex": "#3E6D99"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "terracotta",
          "hex": "#C66A4A"
        }
      ]
    },
    {
      "name": "indigo, rosewater, cream",
      "colors": [
        {
          "name": "indigo",
          "hex": "#4B4A9C"
        },
        {
          "name": "rosewater",
          "hex": "#F5C3CB"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "thyme, peach, ivory",
      "colors": [
        {
          "name": "thyme",
          "hex": "#9AA77B"
        },
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "ivory",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "fern, blush, clay",
      "colors": [
        {
          "name": "fern",
          "hex": "#5F8A4B"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "clay",
          "hex": "#B96A50"
        }
      ]
    },
    {
      "name": "forest, peach, ivory",
      "colors": [
        {
          "name": "forest",
          "hex": "#2F6B3F"
        },
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "ivory",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "cherry, linen, sage",
      "colors": [
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        },
        {
          "name": "sage",
          "hex": "#A9B98F"
        }
      ]
    },
    {
      "name": "charcoal, rosewater, oatmeal",
      "colors": [
        {
          "name": "charcoal",
          "hex": "#2B2B2B"
        },
        {
          "name": "rosewater",
          "hex": "#F5C3CB"
        },
        {
          "name": "oatmeal",
          "hex": "#D8C7A7"
        }
      ]
    },
    {
      "name": "raspberry, olive, cream",
      "colors": [
        {
          "name": "raspberry",
          "hex": "#C13E72"
        },
        {
          "name": "olive",
          "hex": "#7E8F55"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "eucalyptus, cream, rose",
      "colors": [
        {
          "name": "eucalyptus",
          "hex": "#8CA58B"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "rose",
          "hex": "#E98AA8"
        }
      ]
    },
    {
      "name": "slate, oat, buttercream",
      "colors": [
        {
          "name": "slate",
          "hex": "#667085"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "mauve, cream, moss",
      "colors": [
        {
          "name": "mauve",
          "hex": "#B78498"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "moss",
          "hex": "#6F7F4F"
        }
      ]
    },
    {
      "name": "basil, butter, clay",
      "colors": [
        {
          "name": "basil",
          "hex": "#5E7F49"
        },
        {
          "name": "butter",
          "hex": "#F7D75A"
        },
        {
          "name": "clay",
          "hex": "#B96A50"
        }
      ]
    },
    {
      "name": "navy, oat, rose",
      "colors": [
        {
          "name": "navy",
          "hex": "#243A63"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "rose",
          "hex": "#E98AA8"
        }
      ]
    },
    {
      "name": "ink, buttercream, peach",
      "colors": [
        {
          "name": "ink",
          "hex": "#2B2B2B"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "peach",
          "hex": "#F6B08A"
        }
      ]
    },
    {
      "name": "violet, citron, ink",
      "colors": [
        {
          "name": "violet",
          "hex": "#7F62B0"
        },
        {
          "name": "citron",
          "hex": "#D7D857"
        },
        {
          "name": "ink",
          "hex": "#2B2B2B"
        }
      ]
    },
    {
      "name": "cobalt, peach, charcoal",
      "colors": [
        {
          "name": "cobalt",
          "hex": "#2957A4"
        },
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "charcoal",
          "hex": "#2B2B2B"
        }
      ]
    },
    {
      "name": "lavender, rust, milk",
      "colors": [
        {
          "name": "lavender",
          "hex": "#C9B6E4"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "milk",
          "hex": "#FFFDF8"
        }
      ]
    },
    {
      "name": "moss, apricot, slate",
      "colors": [
        {
          "name": "moss",
          "hex": "#6F7F4F"
        },
        {
          "name": "apricot",
          "hex": "#F6B26B"
        },
        {
          "name": "slate",
          "hex": "#667085"
        }
      ]
    },
    {
      "name": "sea blue, lemon, charcoal",
      "colors": [
        {
          "name": "sea blue",
          "hex": "#4AA3C7"
        },
        {
          "name": "lemon",
          "hex": "#F9DA4A"
        },
        {
          "name": "charcoal",
          "hex": "#2B2B2B"
        }
      ]
    },
    {
      "name": "coral, navy, buttercream",
      "colors": [
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "navy",
          "hex": "#243A63"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "terracotta, seafoam, ivory",
      "colors": [
        {
          "name": "terracotta",
          "hex": "#C66A4A"
        },
        {
          "name": "seafoam",
          "hex": "#A7DCC9"
        },
        {
          "name": "ivory",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "auburn, cream, sky",
      "colors": [
        {
          "name": "auburn",
          "hex": "#A4492D"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "sky",
          "hex": "#8FC7E8"
        }
      ]
    },
    {
      "name": "plum, oat, citron",
      "colors": [
        {
          "name": "plum",
          "hex": "#7E4A78"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "citron",
          "hex": "#D7D857"
        }
      ]
    },
    {
      "name": "jade, cream, poppy",
      "colors": [
        {
          "name": "jade",
          "hex": "#4AA77D"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "poppy",
          "hex": "#E85D4A"
        }
      ]
    },
    {
      "name": "olive, coral, linen",
      "colors": [
        {
          "name": "olive",
          "hex": "#7E8F55"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "cherry, oat, cocoa",
      "colors": [
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "cocoa",
          "hex": "#5A3426"
        }
      ]
    },
    {
      "name": "navy, blush, buttercream",
      "colors": [
        {
          "name": "navy",
          "hex": "#243A63"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "mauve, pine, buttercream",
      "colors": [
        {
          "name": "mauve",
          "hex": "#B78498"
        },
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "rose, ink, cream",
      "colors": [
        {
          "name": "rose",
          "hex": "#E98AA8"
        },
        {
          "name": "ink",
          "hex": "#2B2B2B"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "fern, papaya, porcelain",
      "colors": [
        {
          "name": "fern",
          "hex": "#5F8A4B"
        },
        {
          "name": "papaya",
          "hex": "#F49B55"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "indigo, buttercream, sage",
      "colors": [
        {
          "name": "indigo",
          "hex": "#4B4A9C"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "sage",
          "hex": "#A9B98F"
        }
      ]
    },
    {
      "name": "grapefruit, cream, basil",
      "colors": [
        {
          "name": "grapefruit",
          "hex": "#F26B5E"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "basil",
          "hex": "#5E7F49"
        }
      ]
    },
    {
      "name": "walnut, sky blue, cream",
      "colors": [
        {
          "name": "walnut",
          "hex": "#6E4A2E"
        },
        {
          "name": "sky blue",
          "hex": "#8FC7E8"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "moss, rose, cream",
      "colors": [
        {
          "name": "moss",
          "hex": "#6F7F4F"
        },
        {
          "name": "rose",
          "hex": "#E98AA8"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "indigo, gold, porcelain",
      "colors": [
        {
          "name": "indigo",
          "hex": "#4B4A9C"
        },
        {
          "name": "gold",
          "hex": "#D9A441"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "rosewater, charcoal, cream",
      "colors": [
        {
          "name": "rosewater",
          "hex": "#F5C3CB"
        },
        {
          "name": "charcoal",
          "hex": "#2B2B2B"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "fern, buttercream, clay",
      "colors": [
        {
          "name": "fern",
          "hex": "#5F8A4B"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "clay",
          "hex": "#B96A50"
        }
      ]
    },
    {
      "name": "rust, cream, berry",
      "colors": [
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "berry",
          "hex": "#A83B68"
        }
      ]
    },
    {
      "name": "blush, pine, ivory",
      "colors": [
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "ivory",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "peach, linen, sage",
      "colors": [
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        },
        {
          "name": "sage",
          "hex": "#A8B99A"
        }
      ]
    },
    {
      "name": "papaya, porcelain, jade",
      "colors": [
        {
          "name": "papaya",
          "hex": "#F49B55"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        },
        {
          "name": "jade",
          "hex": "#4D8B72"
        }
      ]
    },
    {
      "name": "rust, shell, seafoam",
      "colors": [
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        },
        {
          "name": "seafoam",
          "hex": "#A9D7C7"
        }
      ]
    },
    {
      "name": "terracotta, fog, mint",
      "colors": [
        {
          "name": "terracotta",
          "hex": "#C96F4A"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        },
        {
          "name": "mint",
          "hex": "#B9DFC9"
        }
      ]
    },
    {
      "name": "apricot, almond, pine",
      "colors": [
        {
          "name": "apricot",
          "hex": "#F3B37C"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        },
        {
          "name": "pine",
          "hex": "#2F5A42"
        }
      ]
    },
    {
      "name": "honey, vanilla, forest",
      "colors": [
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        },
        {
          "name": "forest",
          "hex": "#355C49"
        }
      ]
    },
    {
      "name": "marigold, bone, eucalyptus",
      "colors": [
        {
          "name": "marigold",
          "hex": "#F4C542"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        },
        {
          "name": "eucalyptus",
          "hex": "#7FA08A"
        }
      ]
    },
    {
      "name": "poppy, ivory, thyme",
      "colors": [
        {
          "name": "poppy",
          "hex": "#E85D4A"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        },
        {
          "name": "thyme",
          "hex": "#748A57"
        }
      ]
    },
    {
      "name": "cherry, oat, basil",
      "colors": [
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "basil",
          "hex": "#5B7F50"
        }
      ]
    },
    {
      "name": "rose, buttercream, moss",
      "colors": [
        {
          "name": "rose",
          "hex": "#E38A99"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "moss",
          "hex": "#6F7F4F"
        }
      ]
    },
    {
      "name": "tangerine, parchment, spruce",
      "colors": [
        {
          "name": "tangerine",
          "hex": "#F58A3A"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        },
        {
          "name": "spruce",
          "hex": "#3E6B57"
        }
      ]
    },
    {
      "name": "brick, sand, fern",
      "colors": [
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        },
        {
          "name": "fern",
          "hex": "#5E8A55"
        }
      ]
    },
    {
      "name": "cantaloupe, pearl, laurel",
      "colors": [
        {
          "name": "cantaloupe",
          "hex": "#F4A67D"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        },
        {
          "name": "laurel",
          "hex": "#879D69"
        }
      ]
    },
    {
      "name": "gold, cloud, olive",
      "colors": [
        {
          "name": "gold",
          "hex": "#D8A833"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        },
        {
          "name": "olive",
          "hex": "#7E8F55"
        }
      ]
    },
    {
      "name": "coral, cream, sage",
      "colors": [
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "sage",
          "hex": "#A8B99A"
        }
      ]
    },
    {
      "name": "peach, linen, jade",
      "colors": [
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        },
        {
          "name": "jade",
          "hex": "#4D8B72"
        }
      ]
    },
    {
      "name": "papaya, porcelain, seafoam",
      "colors": [
        {
          "name": "papaya",
          "hex": "#F49B55"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        },
        {
          "name": "seafoam",
          "hex": "#A9D7C7"
        }
      ]
    },
    {
      "name": "rust, shell, mint",
      "colors": [
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        },
        {
          "name": "mint",
          "hex": "#B9DFC9"
        }
      ]
    },
    {
      "name": "terracotta, fog, pine",
      "colors": [
        {
          "name": "terracotta",
          "hex": "#C96F4A"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        },
        {
          "name": "pine",
          "hex": "#2F5A42"
        }
      ]
    },
    {
      "name": "apricot, almond, forest",
      "colors": [
        {
          "name": "apricot",
          "hex": "#F3B37C"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        },
        {
          "name": "forest",
          "hex": "#355C49"
        }
      ]
    },
    {
      "name": "honey, vanilla, eucalyptus",
      "colors": [
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        },
        {
          "name": "eucalyptus",
          "hex": "#7FA08A"
        }
      ]
    },
    {
      "name": "marigold, bone, thyme",
      "colors": [
        {
          "name": "marigold",
          "hex": "#F4C542"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        },
        {
          "name": "thyme",
          "hex": "#748A57"
        }
      ]
    },
    {
      "name": "poppy, ivory, basil",
      "colors": [
        {
          "name": "poppy",
          "hex": "#E85D4A"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        },
        {
          "name": "basil",
          "hex": "#5B7F50"
        }
      ]
    },
    {
      "name": "cherry, oat, moss",
      "colors": [
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "moss",
          "hex": "#6F7F4F"
        }
      ]
    },
    {
      "name": "rose, buttercream, spruce",
      "colors": [
        {
          "name": "rose",
          "hex": "#E38A99"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "spruce",
          "hex": "#3E6B57"
        }
      ]
    },
    {
      "name": "tangerine, parchment, fern",
      "colors": [
        {
          "name": "tangerine",
          "hex": "#F58A3A"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        },
        {
          "name": "fern",
          "hex": "#5E8A55"
        }
      ]
    },
    {
      "name": "brick, sand, laurel",
      "colors": [
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        },
        {
          "name": "laurel",
          "hex": "#879D69"
        }
      ]
    },
    {
      "name": "cantaloupe, pearl, olive",
      "colors": [
        {
          "name": "cantaloupe",
          "hex": "#F4A67D"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        },
        {
          "name": "olive",
          "hex": "#7E8F55"
        }
      ]
    },
    {
      "name": "gold, cloud, sage",
      "colors": [
        {
          "name": "gold",
          "hex": "#D8A833"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        },
        {
          "name": "sage",
          "hex": "#A8B99A"
        }
      ]
    },
    {
      "name": "coral, cream, jade",
      "colors": [
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "jade",
          "hex": "#4D8B72"
        }
      ]
    },
    {
      "name": "peach, linen, seafoam",
      "colors": [
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        },
        {
          "name": "seafoam",
          "hex": "#A9D7C7"
        }
      ]
    },
    {
      "name": "papaya, porcelain, mint",
      "colors": [
        {
          "name": "papaya",
          "hex": "#F49B55"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        },
        {
          "name": "mint",
          "hex": "#B9DFC9"
        }
      ]
    },
    {
      "name": "rust, shell, pine",
      "colors": [
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        },
        {
          "name": "pine",
          "hex": "#2F5A42"
        }
      ]
    },
    {
      "name": "terracotta, fog, forest",
      "colors": [
        {
          "name": "terracotta",
          "hex": "#C96F4A"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        },
        {
          "name": "forest",
          "hex": "#355C49"
        }
      ]
    },
    {
      "name": "apricot, almond, eucalyptus",
      "colors": [
        {
          "name": "apricot",
          "hex": "#F3B37C"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        },
        {
          "name": "eucalyptus",
          "hex": "#7FA08A"
        }
      ]
    },
    {
      "name": "honey, vanilla, thyme",
      "colors": [
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        },
        {
          "name": "thyme",
          "hex": "#748A57"
        }
      ]
    },
    {
      "name": "marigold, bone, basil",
      "colors": [
        {
          "name": "marigold",
          "hex": "#F4C542"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        },
        {
          "name": "basil",
          "hex": "#5B7F50"
        }
      ]
    },
    {
      "name": "poppy, ivory, moss",
      "colors": [
        {
          "name": "poppy",
          "hex": "#E85D4A"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        },
        {
          "name": "moss",
          "hex": "#6F7F4F"
        }
      ]
    },
    {
      "name": "cherry, oat, spruce",
      "colors": [
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "spruce",
          "hex": "#3E6B57"
        }
      ]
    },
    {
      "name": "plum, peach, ivory",
      "colors": [
        {
          "name": "plum",
          "hex": "#7E4A78"
        },
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "lavender, rust, porcelain",
      "colors": [
        {
          "name": "lavender",
          "hex": "#C9B6E4"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "berry, apricot, parchment",
      "colors": [
        {
          "name": "berry",
          "hex": "#A83B68"
        },
        {
          "name": "apricot",
          "hex": "#F3B37C"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "aubergine, marigold, almond",
      "colors": [
        {
          "name": "aubergine",
          "hex": "#5F3A5D"
        },
        {
          "name": "marigold",
          "hex": "#F4C542"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "lilac, cherry, cloud",
      "colors": [
        {
          "name": "lilac",
          "hex": "#D7C4ED"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "mulberry, tangerine, ivory",
      "colors": [
        {
          "name": "mulberry",
          "hex": "#8D4E76"
        },
        {
          "name": "tangerine",
          "hex": "#F58A3A"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "orchid, cantaloupe, porcelain",
      "colors": [
        {
          "name": "orchid",
          "hex": "#C88CC8"
        },
        {
          "name": "cantaloupe",
          "hex": "#F4A67D"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "violet, coral, parchment",
      "colors": [
        {
          "name": "violet",
          "hex": "#8A77C8"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "plum, papaya, almond",
      "colors": [
        {
          "name": "plum",
          "hex": "#7E4A78"
        },
        {
          "name": "papaya",
          "hex": "#F49B55"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "lavender, terracotta, cloud",
      "colors": [
        {
          "name": "lavender",
          "hex": "#C9B6E4"
        },
        {
          "name": "terracotta",
          "hex": "#C96F4A"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "berry, honey, ivory",
      "colors": [
        {
          "name": "berry",
          "hex": "#A83B68"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "aubergine, poppy, porcelain",
      "colors": [
        {
          "name": "aubergine",
          "hex": "#5F3A5D"
        },
        {
          "name": "poppy",
          "hex": "#E85D4A"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "lilac, rose, parchment",
      "colors": [
        {
          "name": "lilac",
          "hex": "#D7C4ED"
        },
        {
          "name": "rose",
          "hex": "#E38A99"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "mulberry, brick, almond",
      "colors": [
        {
          "name": "mulberry",
          "hex": "#8D4E76"
        },
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "orchid, gold, cloud",
      "colors": [
        {
          "name": "orchid",
          "hex": "#C88CC8"
        },
        {
          "name": "gold",
          "hex": "#D8A833"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "violet, peach, ivory",
      "colors": [
        {
          "name": "violet",
          "hex": "#8A77C8"
        },
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "plum, rust, porcelain",
      "colors": [
        {
          "name": "plum",
          "hex": "#7E4A78"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "lavender, apricot, parchment",
      "colors": [
        {
          "name": "lavender",
          "hex": "#C9B6E4"
        },
        {
          "name": "apricot",
          "hex": "#F3B37C"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "berry, marigold, almond",
      "colors": [
        {
          "name": "berry",
          "hex": "#A83B68"
        },
        {
          "name": "marigold",
          "hex": "#F4C542"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "aubergine, cherry, cloud",
      "colors": [
        {
          "name": "aubergine",
          "hex": "#5F3A5D"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "lilac, tangerine, ivory",
      "colors": [
        {
          "name": "lilac",
          "hex": "#D7C4ED"
        },
        {
          "name": "tangerine",
          "hex": "#F58A3A"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "mulberry, cantaloupe, porcelain",
      "colors": [
        {
          "name": "mulberry",
          "hex": "#8D4E76"
        },
        {
          "name": "cantaloupe",
          "hex": "#F4A67D"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "orchid, coral, parchment",
      "colors": [
        {
          "name": "orchid",
          "hex": "#C88CC8"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "violet, papaya, almond",
      "colors": [
        {
          "name": "violet",
          "hex": "#8A77C8"
        },
        {
          "name": "papaya",
          "hex": "#F49B55"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "plum, terracotta, cloud",
      "colors": [
        {
          "name": "plum",
          "hex": "#7E4A78"
        },
        {
          "name": "terracotta",
          "hex": "#C96F4A"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "lavender, honey, ivory",
      "colors": [
        {
          "name": "lavender",
          "hex": "#C9B6E4"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "berry, poppy, porcelain",
      "colors": [
        {
          "name": "berry",
          "hex": "#A83B68"
        },
        {
          "name": "poppy",
          "hex": "#E85D4A"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "aubergine, rose, parchment",
      "colors": [
        {
          "name": "aubergine",
          "hex": "#5F3A5D"
        },
        {
          "name": "rose",
          "hex": "#E38A99"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "lilac, brick, almond",
      "colors": [
        {
          "name": "lilac",
          "hex": "#D7C4ED"
        },
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "mulberry, gold, cloud",
      "colors": [
        {
          "name": "mulberry",
          "hex": "#8D4E76"
        },
        {
          "name": "gold",
          "hex": "#D8A833"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "orchid, peach, ivory",
      "colors": [
        {
          "name": "orchid",
          "hex": "#C88CC8"
        },
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "violet, rust, porcelain",
      "colors": [
        {
          "name": "violet",
          "hex": "#8A77C8"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "plum, apricot, parchment",
      "colors": [
        {
          "name": "plum",
          "hex": "#7E4A78"
        },
        {
          "name": "apricot",
          "hex": "#F3B37C"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "lavender, marigold, almond",
      "colors": [
        {
          "name": "lavender",
          "hex": "#C9B6E4"
        },
        {
          "name": "marigold",
          "hex": "#F4C542"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "berry, cherry, cloud",
      "colors": [
        {
          "name": "berry",
          "hex": "#A83B68"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "olive, blush, linen",
      "colors": [
        {
          "name": "olive",
          "hex": "#7E8F55"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "pine, rosewater, porcelain",
      "colors": [
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "rosewater",
          "hex": "#F5C7CF"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "moss, petal, shell",
      "colors": [
        {
          "name": "moss",
          "hex": "#6F7F4F"
        },
        {
          "name": "petal",
          "hex": "#F4B8C8"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        }
      ]
    },
    {
      "name": "sage, bubblegum, fog",
      "colors": [
        {
          "name": "sage",
          "hex": "#A8B99A"
        },
        {
          "name": "bubblegum",
          "hex": "#F2A9C2"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "forest, dusty rose, almond",
      "colors": [
        {
          "name": "forest",
          "hex": "#355C49"
        },
        {
          "name": "dusty rose",
          "hex": "#D89AA3"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "spruce, blush, vanilla",
      "colors": [
        {
          "name": "spruce",
          "hex": "#3E6B57"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        }
      ]
    },
    {
      "name": "jade, rosewater, bone",
      "colors": [
        {
          "name": "jade",
          "hex": "#4D8B72"
        },
        {
          "name": "rosewater",
          "hex": "#F5C7CF"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "eucalyptus, petal, ivory",
      "colors": [
        {
          "name": "eucalyptus",
          "hex": "#7FA08A"
        },
        {
          "name": "petal",
          "hex": "#F4B8C8"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "fern, bubblegum, oat",
      "colors": [
        {
          "name": "fern",
          "hex": "#5E8A55"
        },
        {
          "name": "bubblegum",
          "hex": "#F2A9C2"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        }
      ]
    },
    {
      "name": "seafoam, dusty rose, buttercream",
      "colors": [
        {
          "name": "seafoam",
          "hex": "#A9D7C7"
        },
        {
          "name": "dusty rose",
          "hex": "#D89AA3"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "thyme, blush, parchment",
      "colors": [
        {
          "name": "thyme",
          "hex": "#748A57"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "laurel, rosewater, sand",
      "colors": [
        {
          "name": "laurel",
          "hex": "#879D69"
        },
        {
          "name": "rosewater",
          "hex": "#F5C7CF"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        }
      ]
    },
    {
      "name": "mint, petal, pearl",
      "colors": [
        {
          "name": "mint",
          "hex": "#B9DFC9"
        },
        {
          "name": "petal",
          "hex": "#F4B8C8"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "basil, bubblegum, cloud",
      "colors": [
        {
          "name": "basil",
          "hex": "#5B7F50"
        },
        {
          "name": "bubblegum",
          "hex": "#F2A9C2"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "olive, dusty rose, cream",
      "colors": [
        {
          "name": "olive",
          "hex": "#7E8F55"
        },
        {
          "name": "dusty rose",
          "hex": "#D89AA3"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "pine, blush, linen",
      "colors": [
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "moss, rosewater, porcelain",
      "colors": [
        {
          "name": "moss",
          "hex": "#6F7F4F"
        },
        {
          "name": "rosewater",
          "hex": "#F5C7CF"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "sage, petal, shell",
      "colors": [
        {
          "name": "sage",
          "hex": "#A8B99A"
        },
        {
          "name": "petal",
          "hex": "#F4B8C8"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        }
      ]
    },
    {
      "name": "forest, bubblegum, fog",
      "colors": [
        {
          "name": "forest",
          "hex": "#355C49"
        },
        {
          "name": "bubblegum",
          "hex": "#F2A9C2"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "spruce, dusty rose, almond",
      "colors": [
        {
          "name": "spruce",
          "hex": "#3E6B57"
        },
        {
          "name": "dusty rose",
          "hex": "#D89AA3"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "jade, blush, vanilla",
      "colors": [
        {
          "name": "jade",
          "hex": "#4D8B72"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        }
      ]
    },
    {
      "name": "eucalyptus, rosewater, bone",
      "colors": [
        {
          "name": "eucalyptus",
          "hex": "#7FA08A"
        },
        {
          "name": "rosewater",
          "hex": "#F5C7CF"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "fern, petal, ivory",
      "colors": [
        {
          "name": "fern",
          "hex": "#5E8A55"
        },
        {
          "name": "petal",
          "hex": "#F4B8C8"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "seafoam, bubblegum, oat",
      "colors": [
        {
          "name": "seafoam",
          "hex": "#A9D7C7"
        },
        {
          "name": "bubblegum",
          "hex": "#F2A9C2"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        }
      ]
    },
    {
      "name": "thyme, dusty rose, buttercream",
      "colors": [
        {
          "name": "thyme",
          "hex": "#748A57"
        },
        {
          "name": "dusty rose",
          "hex": "#D89AA3"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "laurel, blush, parchment",
      "colors": [
        {
          "name": "laurel",
          "hex": "#879D69"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "mint, rosewater, sand",
      "colors": [
        {
          "name": "mint",
          "hex": "#B9DFC9"
        },
        {
          "name": "rosewater",
          "hex": "#F5C7CF"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        }
      ]
    },
    {
      "name": "basil, petal, pearl",
      "colors": [
        {
          "name": "basil",
          "hex": "#5B7F50"
        },
        {
          "name": "petal",
          "hex": "#F4B8C8"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "olive, bubblegum, cloud",
      "colors": [
        {
          "name": "olive",
          "hex": "#7E8F55"
        },
        {
          "name": "bubblegum",
          "hex": "#F2A9C2"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "pine, dusty rose, cream",
      "colors": [
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "dusty rose",
          "hex": "#D89AA3"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "moss, blush, linen",
      "colors": [
        {
          "name": "moss",
          "hex": "#6F7F4F"
        },
        {
          "name": "blush",
          "hex": "#EFB7B7"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "sage, rosewater, porcelain",
      "colors": [
        {
          "name": "sage",
          "hex": "#A8B99A"
        },
        {
          "name": "rosewater",
          "hex": "#F5C7CF"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "forest, petal, shell",
      "colors": [
        {
          "name": "forest",
          "hex": "#355C49"
        },
        {
          "name": "petal",
          "hex": "#F4B8C8"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        }
      ]
    },
    {
      "name": "spruce, bubblegum, fog",
      "colors": [
        {
          "name": "spruce",
          "hex": "#3E6B57"
        },
        {
          "name": "bubblegum",
          "hex": "#F2A9C2"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "jade, dusty rose, almond",
      "colors": [
        {
          "name": "jade",
          "hex": "#4D8B72"
        },
        {
          "name": "dusty rose",
          "hex": "#D89AA3"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "cobalt, oat, clay",
      "colors": [
        {
          "name": "cobalt",
          "hex": "#2957A4"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "clay",
          "hex": "#B56C4D"
        }
      ]
    },
    {
      "name": "slate, buttercream, chestnut",
      "colors": [
        {
          "name": "slate",
          "hex": "#667085"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "chestnut",
          "hex": "#8A5B3D"
        }
      ]
    },
    {
      "name": "cornflower, parchment, caramel",
      "colors": [
        {
          "name": "cornflower",
          "hex": "#7EA6E0"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        },
        {
          "name": "caramel",
          "hex": "#C58A4B"
        }
      ]
    },
    {
      "name": "sky, sand, mahogany",
      "colors": [
        {
          "name": "sky",
          "hex": "#9EC9F3"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        },
        {
          "name": "mahogany",
          "hex": "#7E4A39"
        }
      ]
    },
    {
      "name": "indigo, pearl, walnut",
      "colors": [
        {
          "name": "indigo",
          "hex": "#4657A7"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        },
        {
          "name": "walnut",
          "hex": "#705841"
        }
      ]
    },
    {
      "name": "navy, cloud, clay",
      "colors": [
        {
          "name": "navy",
          "hex": "#2E4366"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        },
        {
          "name": "clay",
          "hex": "#B56C4D"
        }
      ]
    },
    {
      "name": "teal, cream, chestnut",
      "colors": [
        {
          "name": "teal",
          "hex": "#4A8DA2"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "chestnut",
          "hex": "#8A5B3D"
        }
      ]
    },
    {
      "name": "ocean, linen, caramel",
      "colors": [
        {
          "name": "ocean",
          "hex": "#3F7C8F"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        },
        {
          "name": "caramel",
          "hex": "#C58A4B"
        }
      ]
    },
    {
      "name": "denim, porcelain, mahogany",
      "colors": [
        {
          "name": "denim",
          "hex": "#5474A4"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        },
        {
          "name": "mahogany",
          "hex": "#7E4A39"
        }
      ]
    },
    {
      "name": "duck egg, shell, walnut",
      "colors": [
        {
          "name": "duck egg",
          "hex": "#BDDCE3"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        },
        {
          "name": "walnut",
          "hex": "#705841"
        }
      ]
    },
    {
      "name": "storm, fog, clay",
      "colors": [
        {
          "name": "storm",
          "hex": "#657C8E"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        },
        {
          "name": "clay",
          "hex": "#B56C4D"
        }
      ]
    },
    {
      "name": "aqua, almond, chestnut",
      "colors": [
        {
          "name": "aqua",
          "hex": "#7CC6CF"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        },
        {
          "name": "chestnut",
          "hex": "#8A5B3D"
        }
      ]
    },
    {
      "name": "cobalt, vanilla, caramel",
      "colors": [
        {
          "name": "cobalt",
          "hex": "#2957A4"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        },
        {
          "name": "caramel",
          "hex": "#C58A4B"
        }
      ]
    },
    {
      "name": "slate, bone, mahogany",
      "colors": [
        {
          "name": "slate",
          "hex": "#667085"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        },
        {
          "name": "mahogany",
          "hex": "#7E4A39"
        }
      ]
    },
    {
      "name": "cornflower, ivory, walnut",
      "colors": [
        {
          "name": "cornflower",
          "hex": "#7EA6E0"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        },
        {
          "name": "walnut",
          "hex": "#705841"
        }
      ]
    },
    {
      "name": "sky, oat, clay",
      "colors": [
        {
          "name": "sky",
          "hex": "#9EC9F3"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "clay",
          "hex": "#B56C4D"
        }
      ]
    },
    {
      "name": "indigo, buttercream, chestnut",
      "colors": [
        {
          "name": "indigo",
          "hex": "#4657A7"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "chestnut",
          "hex": "#8A5B3D"
        }
      ]
    },
    {
      "name": "navy, parchment, caramel",
      "colors": [
        {
          "name": "navy",
          "hex": "#2E4366"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        },
        {
          "name": "caramel",
          "hex": "#C58A4B"
        }
      ]
    },
    {
      "name": "teal, sand, mahogany",
      "colors": [
        {
          "name": "teal",
          "hex": "#4A8DA2"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        },
        {
          "name": "mahogany",
          "hex": "#7E4A39"
        }
      ]
    },
    {
      "name": "ocean, pearl, walnut",
      "colors": [
        {
          "name": "ocean",
          "hex": "#3F7C8F"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        },
        {
          "name": "walnut",
          "hex": "#705841"
        }
      ]
    },
    {
      "name": "denim, cloud, clay",
      "colors": [
        {
          "name": "denim",
          "hex": "#5474A4"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        },
        {
          "name": "clay",
          "hex": "#B56C4D"
        }
      ]
    },
    {
      "name": "duck egg, cream, chestnut",
      "colors": [
        {
          "name": "duck egg",
          "hex": "#BDDCE3"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        },
        {
          "name": "chestnut",
          "hex": "#8A5B3D"
        }
      ]
    },
    {
      "name": "storm, linen, caramel",
      "colors": [
        {
          "name": "storm",
          "hex": "#657C8E"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        },
        {
          "name": "caramel",
          "hex": "#C58A4B"
        }
      ]
    },
    {
      "name": "aqua, porcelain, mahogany",
      "colors": [
        {
          "name": "aqua",
          "hex": "#7CC6CF"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        },
        {
          "name": "mahogany",
          "hex": "#7E4A39"
        }
      ]
    },
    {
      "name": "cobalt, shell, walnut",
      "colors": [
        {
          "name": "cobalt",
          "hex": "#2957A4"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        },
        {
          "name": "walnut",
          "hex": "#705841"
        }
      ]
    },
    {
      "name": "slate, fog, clay",
      "colors": [
        {
          "name": "slate",
          "hex": "#667085"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        },
        {
          "name": "clay",
          "hex": "#B56C4D"
        }
      ]
    },
    {
      "name": "cornflower, almond, chestnut",
      "colors": [
        {
          "name": "cornflower",
          "hex": "#7EA6E0"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        },
        {
          "name": "chestnut",
          "hex": "#8A5B3D"
        }
      ]
    },
    {
      "name": "sky, vanilla, caramel",
      "colors": [
        {
          "name": "sky",
          "hex": "#9EC9F3"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        },
        {
          "name": "caramel",
          "hex": "#C58A4B"
        }
      ]
    },
    {
      "name": "indigo, bone, mahogany",
      "colors": [
        {
          "name": "indigo",
          "hex": "#4657A7"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        },
        {
          "name": "mahogany",
          "hex": "#7E4A39"
        }
      ]
    },
    {
      "name": "navy, ivory, walnut",
      "colors": [
        {
          "name": "navy",
          "hex": "#2E4366"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        },
        {
          "name": "walnut",
          "hex": "#705841"
        }
      ]
    },
    {
      "name": "teal, oat, clay",
      "colors": [
        {
          "name": "teal",
          "hex": "#4A8DA2"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        },
        {
          "name": "clay",
          "hex": "#B56C4D"
        }
      ]
    },
    {
      "name": "ocean, buttercream, chestnut",
      "colors": [
        {
          "name": "ocean",
          "hex": "#3F7C8F"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        },
        {
          "name": "chestnut",
          "hex": "#8A5B3D"
        }
      ]
    },
    {
      "name": "denim, parchment, caramel",
      "colors": [
        {
          "name": "denim",
          "hex": "#5474A4"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        },
        {
          "name": "caramel",
          "hex": "#C58A4B"
        }
      ]
    },
    {
      "name": "duck egg, sand, mahogany",
      "colors": [
        {
          "name": "duck egg",
          "hex": "#BDDCE3"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        },
        {
          "name": "mahogany",
          "hex": "#7E4A39"
        }
      ]
    },
    {
      "name": "storm, pearl, walnut",
      "colors": [
        {
          "name": "storm",
          "hex": "#657C8E"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        },
        {
          "name": "walnut",
          "hex": "#705841"
        }
      ]
    },
    {
      "name": "cobalt, coral, porcelain",
      "colors": [
        {
          "name": "cobalt",
          "hex": "#2957A4"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "slate, rust, shell",
      "colors": [
        {
          "name": "slate",
          "hex": "#667085"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        }
      ]
    },
    {
      "name": "cornflower, honey, fog",
      "colors": [
        {
          "name": "cornflower",
          "hex": "#7EA6E0"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "sky, cherry, almond",
      "colors": [
        {
          "name": "sky",
          "hex": "#9EC9F3"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "indigo, brick, vanilla",
      "colors": [
        {
          "name": "indigo",
          "hex": "#4657A7"
        },
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        }
      ]
    },
    {
      "name": "navy, coral, bone",
      "colors": [
        {
          "name": "navy",
          "hex": "#2E4366"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "teal, rust, ivory",
      "colors": [
        {
          "name": "teal",
          "hex": "#4A8DA2"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "ocean, honey, oat",
      "colors": [
        {
          "name": "ocean",
          "hex": "#3F7C8F"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        }
      ]
    },
    {
      "name": "denim, cherry, buttercream",
      "colors": [
        {
          "name": "denim",
          "hex": "#5474A4"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "duck egg, brick, parchment",
      "colors": [
        {
          "name": "duck egg",
          "hex": "#BDDCE3"
        },
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "storm, coral, sand",
      "colors": [
        {
          "name": "storm",
          "hex": "#657C8E"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        }
      ]
    },
    {
      "name": "aqua, rust, pearl",
      "colors": [
        {
          "name": "aqua",
          "hex": "#7CC6CF"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "cobalt, honey, cloud",
      "colors": [
        {
          "name": "cobalt",
          "hex": "#2957A4"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "slate, cherry, cream",
      "colors": [
        {
          "name": "slate",
          "hex": "#667085"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "cornflower, brick, linen",
      "colors": [
        {
          "name": "cornflower",
          "hex": "#7EA6E0"
        },
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "sky, coral, porcelain",
      "colors": [
        {
          "name": "sky",
          "hex": "#9EC9F3"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "porcelain",
          "hex": "#F2F6F7"
        }
      ]
    },
    {
      "name": "indigo, rust, shell",
      "colors": [
        {
          "name": "indigo",
          "hex": "#4657A7"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        }
      ]
    },
    {
      "name": "navy, honey, fog",
      "colors": [
        {
          "name": "navy",
          "hex": "#2E4366"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "teal, cherry, almond",
      "colors": [
        {
          "name": "teal",
          "hex": "#4A8DA2"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "ocean, brick, vanilla",
      "colors": [
        {
          "name": "ocean",
          "hex": "#3F7C8F"
        },
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        }
      ]
    },
    {
      "name": "denim, coral, bone",
      "colors": [
        {
          "name": "denim",
          "hex": "#5474A4"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "duck egg, rust, ivory",
      "colors": [
        {
          "name": "duck egg",
          "hex": "#BDDCE3"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "storm, honey, oat",
      "colors": [
        {
          "name": "storm",
          "hex": "#657C8E"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        }
      ]
    },
    {
      "name": "aqua, cherry, buttercream",
      "colors": [
        {
          "name": "aqua",
          "hex": "#7CC6CF"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "cobalt, brick, parchment",
      "colors": [
        {
          "name": "cobalt",
          "hex": "#2957A4"
        },
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "slate, coral, sand",
      "colors": [
        {
          "name": "slate",
          "hex": "#667085"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        }
      ]
    },
    {
      "name": "cornflower, rust, pearl",
      "colors": [
        {
          "name": "cornflower",
          "hex": "#7EA6E0"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "sky, honey, cloud",
      "colors": [
        {
          "name": "sky",
          "hex": "#9EC9F3"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    },
    {
      "name": "indigo, cherry, cream",
      "colors": [
        {
          "name": "indigo",
          "hex": "#4657A7"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "cream",
          "hex": "#FFF6E4"
        }
      ]
    },
    {
      "name": "navy, brick, linen",
      "colors": [
        {
          "name": "navy",
          "hex": "#2E4366"
        },
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "olive, apricot, buttercream",
      "colors": [
        {
          "name": "olive",
          "hex": "#7E8F55"
        },
        {
          "name": "apricot",
          "hex": "#F3B37C"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "pine, marigold, fog",
      "colors": [
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "marigold",
          "hex": "#F4C542"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "moss, cherry, pearl",
      "colors": [
        {
          "name": "moss",
          "hex": "#6F7F4F"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "sage, tangerine, bone",
      "colors": [
        {
          "name": "sage",
          "hex": "#A8B99A"
        },
        {
          "name": "tangerine",
          "hex": "#F58A3A"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "forest, cantaloupe, linen",
      "colors": [
        {
          "name": "forest",
          "hex": "#355C49"
        },
        {
          "name": "cantaloupe",
          "hex": "#F4A67D"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "spruce, coral, buttercream",
      "colors": [
        {
          "name": "spruce",
          "hex": "#3E6B57"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "jade, papaya, fog",
      "colors": [
        {
          "name": "jade",
          "hex": "#4D8B72"
        },
        {
          "name": "papaya",
          "hex": "#F49B55"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "eucalyptus, terracotta, pearl",
      "colors": [
        {
          "name": "eucalyptus",
          "hex": "#7FA08A"
        },
        {
          "name": "terracotta",
          "hex": "#C96F4A"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "fern, honey, bone",
      "colors": [
        {
          "name": "fern",
          "hex": "#5E8A55"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "seafoam, poppy, linen",
      "colors": [
        {
          "name": "seafoam",
          "hex": "#A9D7C7"
        },
        {
          "name": "poppy",
          "hex": "#E85D4A"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "thyme, rose, buttercream",
      "colors": [
        {
          "name": "thyme",
          "hex": "#748A57"
        },
        {
          "name": "rose",
          "hex": "#E38A99"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "laurel, brick, fog",
      "colors": [
        {
          "name": "laurel",
          "hex": "#879D69"
        },
        {
          "name": "brick",
          "hex": "#B85545"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "mint, gold, pearl",
      "colors": [
        {
          "name": "mint",
          "hex": "#B9DFC9"
        },
        {
          "name": "gold",
          "hex": "#D8A833"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "basil, peach, bone",
      "colors": [
        {
          "name": "basil",
          "hex": "#5B7F50"
        },
        {
          "name": "peach",
          "hex": "#F6B08A"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "olive, rust, linen",
      "colors": [
        {
          "name": "olive",
          "hex": "#7E8F55"
        },
        {
          "name": "rust",
          "hex": "#B85D34"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "pine, apricot, buttercream",
      "colors": [
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "apricot",
          "hex": "#F3B37C"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "moss, marigold, fog",
      "colors": [
        {
          "name": "moss",
          "hex": "#6F7F4F"
        },
        {
          "name": "marigold",
          "hex": "#F4C542"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "sage, cherry, pearl",
      "colors": [
        {
          "name": "sage",
          "hex": "#A8B99A"
        },
        {
          "name": "cherry",
          "hex": "#D92E3A"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "forest, tangerine, bone",
      "colors": [
        {
          "name": "forest",
          "hex": "#355C49"
        },
        {
          "name": "tangerine",
          "hex": "#F58A3A"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "spruce, cantaloupe, linen",
      "colors": [
        {
          "name": "spruce",
          "hex": "#3E6B57"
        },
        {
          "name": "cantaloupe",
          "hex": "#F4A67D"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "jade, coral, buttercream",
      "colors": [
        {
          "name": "jade",
          "hex": "#4D8B72"
        },
        {
          "name": "coral",
          "hex": "#F28C6B"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "eucalyptus, papaya, fog",
      "colors": [
        {
          "name": "eucalyptus",
          "hex": "#7FA08A"
        },
        {
          "name": "papaya",
          "hex": "#F49B55"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "fern, terracotta, pearl",
      "colors": [
        {
          "name": "fern",
          "hex": "#5E8A55"
        },
        {
          "name": "terracotta",
          "hex": "#C96F4A"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "seafoam, honey, bone",
      "colors": [
        {
          "name": "seafoam",
          "hex": "#A9D7C7"
        },
        {
          "name": "honey",
          "hex": "#FFBA05"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "thyme, poppy, linen",
      "colors": [
        {
          "name": "thyme",
          "hex": "#748A57"
        },
        {
          "name": "poppy",
          "hex": "#E85D4A"
        },
        {
          "name": "linen",
          "hex": "#F1E5D0"
        }
      ]
    },
    {
      "name": "plum, pine, shell",
      "colors": [
        {
          "name": "plum",
          "hex": "#7E4A78"
        },
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "shell",
          "hex": "#F9EFE2"
        }
      ]
    },
    {
      "name": "lavender, sage, fog",
      "colors": [
        {
          "name": "lavender",
          "hex": "#C9B6E4"
        },
        {
          "name": "sage",
          "hex": "#A8B99A"
        },
        {
          "name": "fog",
          "hex": "#E8EDF0"
        }
      ]
    },
    {
      "name": "berry, spruce, almond",
      "colors": [
        {
          "name": "berry",
          "hex": "#A83B68"
        },
        {
          "name": "spruce",
          "hex": "#3E6B57"
        },
        {
          "name": "almond",
          "hex": "#EBDCC5"
        }
      ]
    },
    {
      "name": "aubergine, eucalyptus, vanilla",
      "colors": [
        {
          "name": "aubergine",
          "hex": "#5F3A5D"
        },
        {
          "name": "eucalyptus",
          "hex": "#7FA08A"
        },
        {
          "name": "vanilla",
          "hex": "#F8E7B9"
        }
      ]
    },
    {
      "name": "lilac, seafoam, bone",
      "colors": [
        {
          "name": "lilac",
          "hex": "#D7C4ED"
        },
        {
          "name": "seafoam",
          "hex": "#A9D7C7"
        },
        {
          "name": "bone",
          "hex": "#E9DDCF"
        }
      ]
    },
    {
      "name": "mulberry, laurel, ivory",
      "colors": [
        {
          "name": "mulberry",
          "hex": "#8D4E76"
        },
        {
          "name": "laurel",
          "hex": "#879D69"
        },
        {
          "name": "ivory",
          "hex": "#FFF9EE"
        }
      ]
    },
    {
      "name": "orchid, basil, oat",
      "colors": [
        {
          "name": "orchid",
          "hex": "#C88CC8"
        },
        {
          "name": "basil",
          "hex": "#5B7F50"
        },
        {
          "name": "oat",
          "hex": "#D8C49A"
        }
      ]
    },
    {
      "name": "violet, pine, buttercream",
      "colors": [
        {
          "name": "violet",
          "hex": "#8A77C8"
        },
        {
          "name": "pine",
          "hex": "#2F5A42"
        },
        {
          "name": "buttercream",
          "hex": "#FFF0B8"
        }
      ]
    },
    {
      "name": "plum, sage, parchment",
      "colors": [
        {
          "name": "plum",
          "hex": "#7E4A78"
        },
        {
          "name": "sage",
          "hex": "#A8B99A"
        },
        {
          "name": "parchment",
          "hex": "#F3E7CF"
        }
      ]
    },
    {
      "name": "lavender, spruce, sand",
      "colors": [
        {
          "name": "lavender",
          "hex": "#C9B6E4"
        },
        {
          "name": "spruce",
          "hex": "#3E6B57"
        },
        {
          "name": "sand",
          "hex": "#E7D3B0"
        }
      ]
    },
    {
      "name": "berry, eucalyptus, pearl",
      "colors": [
        {
          "name": "berry",
          "hex": "#A83B68"
        },
        {
          "name": "eucalyptus",
          "hex": "#7FA08A"
        },
        {
          "name": "pearl",
          "hex": "#F8F7F3"
        }
      ]
    },
    {
      "name": "aubergine, seafoam, cloud",
      "colors": [
        {
          "name": "aubergine",
          "hex": "#5F3A5D"
        },
        {
          "name": "seafoam",
          "hex": "#A9D7C7"
        },
        {
          "name": "cloud",
          "hex": "#EDF3F5"
        }
      ]
    }
  ],
  "library": {
    "artSupplySubjects": [
      "paint tube",
      "ink bottle",
      "brush jar",
      "paint palette",
      "paintbrush",
      "pencil",
      "colored pencil bundle",
      "marker trio",
      "fountain pen",
      "dip pen",
      "color wheel",
      "paint cup",
      "scissors",
      "pin cushion",
      "yarn ball",
      "camera",
      "harp",
      "piano",
      "flute",
      "drumset",
      "accordion"
    ],
    "paperMailSubjects": [
      "postcard",
      "envelope",
      "postage stamp",
      "ticket stub",
      "library card",
      "recipe card",
      "bookmark",
      "greeting card",
      "sticker sheet",
      "matchbox",
      "gift tag",
      "paper lantern",
      "love letter",
      "trading card"
    ],
    "cozyHomeSubjects": [
      "teacup",
      "kettle",
      "chair",
      "lamp",
      "candle",
      "mirror",
      "clock",
      "picture frame",
      "breakfast tray",
      "little vase",
      "window",
      "laundry basket",
      "bookshelf",
      "fireplace",
      "mantel",
      "rocking chair",
      "armchair",
      "floor lamp",
      "wall shelf",
      "jewelry box",
      "record player",
      "teapot",
      "houseplant",
      "cuckoo clock",
      "doll",
      "cat eye glasses"
    ],
    "kitchenBakerySubjects": [
      "jam jar",
      "croissant",
      "cake slice",
      "pie",
      "butter dish",
      "honey jar",
      "soup bowl",
      "teapot",
      "spoon",
      "berry basket",
      "lemon",
      "pear",
      "carrot bunch",
      "cupcake",
      "loaf of bread",
      "picnic basket",
      "rolling pin",
      "measuring cup",
      "cake stand",
      "sugar bowl",
      "milk bottle",
      "fruit tart",
      "cinnamon roll",
      "strawberry basket",
      "tea tin",
      "bread basket",
      "bundt cake",
      "tartlet",
      "macaron",
      "madeleine",
      "pretzel",
      "baguette",
      "scone",
      "jam tart",
      "waffle",
      "pancakes",
      "coffee pot",
      "cocoa mug",
      "teacup and saucer",
      "syrup bottle",
      "spice jar",
      "flour sack",
      "sugar jar",
      "olive jar",
      "pickle jar",
      "peach",
      "apple",
      "strawberry",
      "fig",
      "tomato",
      "radish bunch",
      "herb bundle",
      "garlic bulb"
    ],
    "plantsGardenNatureSubjects": [
      "wildflower",
      "daisy",
      "tulip",
      "poppy",
      "peony",
      "ranunculus",
      "anemone",
      "cosmos",
      "marigold",
      "pansy",
      "iris",
      "sunflower",
      "lavender sprig",
      "chamomile",
      "clover",
      "dandelion",
      "thistle",
      "blooming branch",
      "flower stem",
      "pressed flower",
      "fern",
      "ivy",
      "eucalyptus stem",
      "olive branch",
      "oak leaf",
      "maple leaf",
      "palm leaf",
      "monstera leaf",
      "sprig",
      "branch",
      "berry",
      "berry stem",
      "seed pod",
      "vine",
      "leafy wreath",
      "pine branch",
      "cactus",
      "succulent",
      "hanging plant",
      "seed packet",
      "watering can",
      "plant pot",
      "terracotta pot",
      "garden gloves",
      "pruning shears",
      "garden basket",
      "plant marker",
      "seed tray",
      "greenhouse",
      "birdhouse",
      "garden gate",
      "wheelbarrow",
      "barrel",
      "mushroom",
      "acorn",
      "pinecone",
      "tree stump",
      "fallen leaf",
      "twig bundle",
      "nest",
      "feather",
      "snail shell",
      "lichen patch",
      "forest path",
      "cabin",
      "trail sign",
      "cloud",
      "rain cloud",
      "rainbow",
      "sun",
      "moon",
      "star",
      "comet",
      "snowflake",
      "raindrop",
      "puddle",
      "wave",
      "tide pool",
      "mountain",
      "hill"
    ],
    "animalSubjects": [
      "pigeon",
      "snail",
      "bee",
      "butterfly",
      "frog",
      "rabbit",
      "fox",
      "owl",
      "hedgehog",
      "turtle",
      "cat",
      "dog",
      "duck",
      "mouse",
      "squirrel",
      "raccoon",
      "otter",
      "crab",
      "fish",
      "moth",
      "goose",
      "swan",
      "badger",
      "deer",
      "bear",
      "bat",
      "seal",
      "whale",
      "seahorse",
      "octopus",
      "jellyfish",
      "ladybug",
      "beetle",
      "dragonfly",
      "firefly",
      "caterpillar",
      "worm",
      "mole",
      "chipmunk",
      "sparrow",
      "robin",
      "crow",
      "pelican",
      "puffin",
      "sheep",
      "goat",
      "llama",
      "pony",
      "donkey",
      "chicken",
      "cow",
      "pig",
      "snake",
      "hare",
      "field mouse",
      "fawn",
      "black bear",
      "beaver",
      "possum",
      "skunk",
      "weasel",
      "ferret",
      "wolf",
      "coyote",
      "bobcat",
      "lynx",
      "songbird",
      "wren",
      "finch",
      "bluebird",
      "chickadee",
      "swallow",
      "dove",
      "raven",
      "magpie",
      "barn owl",
      "hawk",
      "heron",
      "egret",
      "crane",
      "seagull",
      "toad",
      "newt",
      "salamander",
      "slug",
      "bumblebee",
      "grasshopper",
      "cricket",
      "spider",
      "kitten",
      "puppy",
      "lamb",
      "calf",
      "horse",
      "piglet",
      "rooster",
      "hen",
      "chick",
      "turkey",
      "duckling",
      "gnome",
      "elf",
      "fairy",
      "sprite",
      "pixie",
      "mermaid",
      "sea witch",
      "selkie",
      "sea nymph",
      "water sprite",
      "unicorn",
      "narwhal"
    ],
    "travelOutdoorsSubjects": [
      "suitcase",
      "camp mug",
      "lantern",
      "canoe",
      "trail sign",
      "hiking boots",
      "camera",
      "map",
      "compass",
      "lighthouse",
      "cabin",
      "tent",
      "buoy",
      "sailboat",
      "beach umbrella",
      "train ticket",
      "station clock",
      "backpack",
      "thermos",
      "binoculars",
      "campfire",
      "picnic blanket",
      "rowboat",
      "paddle",
      "life preserver",
      "anchor",
      "beach chair",
      "sandcastle",
      "beach bucket",
      "kite",
      "hot air balloon",
      "camper van",
      "bicycle",
      "train car",
      "bus stop",
      "road sign",
      "mountain cabin",
      "ski lift",
      "snow globe",
      "travel trunk",
      "luggage tag",
      "passport",
      "ferry",
      "boots",
      "ballet shoes"
    ],
    "miniArchitectureSubjects": [
      "doorway",
      "garden gate",
      "greenhouse",
      "cabin",
      "cottage",
      "lighthouse",
      "flower stand",
      "market stall",
      "bookshop",
      "art supply shop",
      "bakery window",
      "plant shop",
      "post office",
      "library cart",
      "studio desk",
      "pantry shelf",
      "porch step",
      "window display",
      "train platform",
      "bridge",
      "garden shed",
      "tool shed",
      "potting bench",
      "picnic table",
      "treehouse",
      "birdhouse",
      "doghouse",
      "camper van",
      "food cart",
      "lemonade stand",
      "newsstand",
      "ticket booth",
      "carousel",
      "bus stop",
      "boat house",
      "seaside cottage",
      "mountain cabin",
      "mushroom house",
      "fairy door",
      "arched window",
      "shop window",
      "bay window",
      "attic window",
      "balcony",
      "courtyard",
      "alleyway",
      "cobblestone path",
      "garden path",
      "front stoop",
      "porch swing",
      "window box",
      "flower cart",
      "produce stand",
      "tea stand",
      "bakery counter",
      "library nook",
      "reading nook",
      "museum",
      "circus tent",
      "apothecary"
    ],
    "decorativeMotifSubjects": [
      "bow",
      "ribbon",
      "key",
      "crown",
      "shell",
      "moon",
      "star",
      "sun",
      "heart",
      "flower",
      "leaf",
      "feather",
      "mushroom",
      "acorn",
      "pinecone",
      "berry",
      "branch",
      "wreath",
      "locket",
      "bell",
      "lantern",
      "charm",
      "pendant",
      "cameo",
      "scallop frame",
      "oval frame",
      "postage stamp frame",
      "ticket frame",
      "arched frame",
      "label frame",
      "ribbon frame",
      "floral frame",
      "vine frame",
      "sunburst frame",
      "quilt block frame",
      "picture frame",
      "window frame",
      "embroidery hoop",
      "pennant",
      "crest",
      "badge",
      "checker tile",
      "quilt block",
      "scallop",
      "arch",
      "teardrop",
      "diamond",
      "starburst",
      "spiral",
      "fan shape",
      "ogee shape",
      "postage stamp",
      "ticket stub",
      "playing card",
      "domino",
      "button",
      "pin cushion",
      "patch",
      "fern",
      "ivy",
      "daisy",
      "tulip",
      "poppy",
      "wildflower",
      "seed pod",
      "clover",
      "strawberry",
      "lemon slice",
      "pear",
      "cherry",
      "olive branch",
      "oak leaf",
      "maple leaf",
      "palm leaf",
      "seaweed",
      "coral",
      "wave",
      "cloud",
      "bird",
      "horse",
      "fish",
      "house",
      "tree",
      "butterfly",
      "painted egg",
      "nesting doll",
      "paper doll",
      "little house",
      "garden gate",
      "birdhouse",
      "carousel horse",
      "toy block",
      "spinning top",
      "kite",
      "bubbles",
      "constellation",
      "puppet",
      "sunflower"
    ],
    "fullChaosFormats": [
      "field guide",
      "sticker sheet",
      "postcard set",
      "label set",
      "mini travel poster",
      "recipe card",
      "menu board",
      "shop window",
      "window display",
      "map",
      "market map",
      "book cover",
      "greeting card",
      "packaging label",
      "stamp set",
      "illustrated checklist",
      "supply guide",
      "tiny zine page",
      "poster set",
      "camp badge",
      "enamel pin set",
      "tea tin label",
      "jar label",
      "recipe booklet cover",
      "illustrated menu",
      "garden marker set",
      "calendar page",
      "tote bag graphic",
      "t-shirt graphic",
      "wrapping paper layout",
      "postcard backside",
      "bookplate",
      "library card design",
      "field notes spread",
      "color palette card",
      "storefront sign"
    ],
    "styleModifiers": {
      "handmade": [
        "painted",
        "hand-painted",
        "stamped",
        "block-printed",
        "paper-cut",
        "stitched",
        "carved",
        "collaged",
        "sketched",
        "inky",
        "textured",
        "speckled",
        "layered",
        "cut-paper",
        "linocut-inspired"
      ],
      "shape": [
        "scalloped",
        "arched",
        "symmetrical",
        "wonky",
        "ornate",
        "minimal",
        "chunky",
        "delicate",
        "bold",
        "rounded",
        "wavy",
        "tiled",
        "framed",
        "striped",
        "dotted",
        "checkered",
        "patchwork",
        "curvy",
        "leafy",
        "floral",
        "imperfect",
        "dainty",
        "lush",
        "overgrown",
        "sketchy"
      ],
      "vibe": [
        "folk",
        "storybook",
        "vintage-inspired",
        "decorative",
        "playful",
        "cozy",
        "botanical",
        "cottage-y",
        "storybook-ish",
        "whimsical",
        "cheerful",
        "charming",
        "nostalgic",
        "campy",
        "seaside",
        "pirate",
        "bubbly",
        "silly",
        "cutie-pie",
        "ethereal",
        "cosmic",
        "heirloom",
        "quirky",
        "rustic",
        "sweet",
        "sunny",
        "romantic",
        "old-fashioned",
        "fairytale",
        "magical",
        "cottagecore",
        "clowncore",
        "joyful",
        "coastal",
        "grandma-chic",
        "grandpa-chic",
        "autumnal",
        "kitschy",
        "farmhouse",
        "cottage",
        "well-loved",
        "folksy",
        "sprightly",
        "pastoral",
        "earthy",
        "dreamy",
        "antique",
        "sun-kissed",
        "foraged",
        "twinkly",
        "glowing",
        "starlit",
        "moonlit",
        "sunlit",
        "dewy",
        "rainy",
        "miniature",
        "childlike",
        "folkloric",
        "legendary",
        "theatrical",
        "eclectic",
        "maximal"
      ],
      "pattern": [
        "striped",
        "dotted",
        "checked",
        "gingham",
        "plaid",
        "scalloped",
        "speckled",
        "crosshatched",
        "tiled",
        "gridded",
        "terrazzo",
        "confetti-covered",
        "floral",
        "leafy",
        "starry",
        "stamped",
        "spotted",
        "polka-dotted",
        "pinstriped",
        "wide-striped",
        "wavy-striped",
        "zigzag",
        "chevron",
        "checkerboard",
        "diamond",
        "harlequin",
        "argyle",
        "diagonal-striped",
        "trailing",
        "ditzy",
        "mosaic",
        "paisley",
        "kaleidoscopic",
        "bordered",
        "scattered",
        "clustered",
        "alternating",
        "offset",
        "tossed",
        "symmetrical",
        "mirrored",
        "overlapping",
        "negative-space",
        "tone-on-tone"
      ]
    },
    "characterRoles": [
      "postmaster",
      "librarian",
      "bookseller",
      "painter",
      "potter",
      "tailor",
      "florist",
      "baker",
      "tea host",
      "soup maker",
      "market vendor",
      "pastry chef",
      "chef",
      "gardener",
      "mapmaker",
      "photographer",
      "trail guide",
      "field guide",
      "forager",
      "birdwatcher",
      "shopkeeper",
      "pirate",
      "sailor",
      "fisherman",
      "clam digger",
      "beachcomber",
      "witch",
      "wizard",
      "magician",
      "fortune teller",
      "alchemist",
      "herbalist",
      "spellmaker",
      "princess",
      "prince",
      "queen",
      "king",
      "knight",
      "jester",
      "farmer",
      "shepherd",
      "milkman",
      "apothecary",
      "dancer",
      "nurse",
      "puppeteer",
      "acrobat",
      "fire dancer",
      "juggler"
    ],
    "weirdObjectTransformations": [
      "teacup with a staircase inside",
      "lighthouse inside a jam jar",
      "boot that works as a shop",
      "suitcase full of windows",
      "kettle growing leaves",
      "paint tube growing flowers",
      "mailbox for butterflies",
      "lantern with roots",
      "mushroom with a front door",
      "teapot with a roof",
      "shell with a window",
      "chair with mushroom legs",
      "matchbox with a room inside",
      "soup bowl with a bridge across it",
      "open book with a garden inside",
      "clock with flower petals for numbers",
      "pear with a balcony",
      "jar with weather inside",
      "spoon with a scene in the bowl",
      "postcard shaped like a house",
      "acorn with a chimney",
      "clock with flower petals",
      "mushroom circus tent",
      "snail carriage",
      "bathtub galloping on horse legs",
      "loaf of bread wearing roller skates",
      "chair wearing shoes",
      "erupting cupcake",
      "paint tube squeezing out a snake",
      "trumpet blowing bubbles",
      "kite dragging the sky behind it",
      "moon melting into a teacup",
      "ladder walking away on tiny feet",
      "flower ringing like a bell",
      "teapot pouring stars",
      "candle casting a butterfly shadow",
      "house wearing rain boots",
      "fish swimming through wallpaper",
      "cloud sleeping in a suitcase",
      "carrot playing the trumpet",
      "mushroom holding up the moon",
      "slipper with windows",
      "cake slice with a drawbridge",
      "lantern full of tiny fish",
      "apple with a spiral staircase",
      "book flapping like a bird",
      "umbrella raining upward",
      "piano growing mushrooms",
      "cuckoo clock releasing bubbles",
      "accordion stretching into a bridge",
      "parasol with a tiny storm underneath",
      "chair growing antlers",
      "dollhouse floating like a balloon",
      "boots sprouting flower stems",
      "teacup sailing across a puddle",
      "sunflower wearing a tiny crown",
      "cottage with chicken legs",
      "harp with vines for strings",
      "record player spinning the moon",
      "paintbrush sweeping up stars",
      "shell opening into a theater"
    ],
    "weirdCreatureConditions": [
      "with a shell-shaped house",
      "carrying an object much too large",
      "sitting inside a teacup",
      "tucked into a postage stamp frame",
      "with window-shaped markings",
      "wearing a lampshade like a hat",
      "pulling a ribbon that becomes a path",
      "with flowers growing from its tail",
      "wearing a cake like a hat",
      "inside a matchbox",
      "under an umbrella made of leaves",
      "wearing a backpack shaped like a house",
      "with a little door on its back",
      "floating in a soup bowl like a boat",
      "carrying a lantern bigger than its body",
      "sitting on a stack of postage stamps",
      "holding a key larger than its head",
      "standing inside a picture frame",
      "standing on stilts made of pencils",
      "with a tail tied in a bow",
      "carrying a sleeping moon",
      "wearing a quilt like a cape",
      "with spots that look like moons",
      "with a shadow doing something different",
      "melting into a puddle of stars",
      "with horns made of smoke",
      "with a body that looks inflated",
      "wearing a cloud as a backpack",
      "with wings made of postage stamps",
      "balancing a tiny cottage on its head",
      "pulling a moon on a string",
      "with a belly full of tiny windows",
      "wearing rain boots on every foot",
      "holding a lantern full of fish",
      "with a crown made of mushrooms",
      "casting a shadow shaped like a different creature",
      "carrying a teacup bigger than its body",
      "wearing a collar of tiny stars",
      "with a staircase curling around its tail",
      "sleeping inside a flower",
      "with ears shaped like little moons",
      "painting the sky with a brush",
      "wearing a curtain like a cape",
      "with spots that turn into bubbles",
      "standing inside a tiny museum display",
      "dragging a puddle behind it",
      "holding an umbrella that grows leaves",
      "wearing a hat with a doorway in it",
      "floating inside a soap bubble",
      "with a tiny stage on its back",
      "carrying a basket of glowing acorns",
      "wearing ballet shoes on mismatched feet"
    ],
    "weirdPatternPrompts": [],
    "twists": [
      "Make one object much larger than the rest.",
      "Let one object overlap the edge of the composition.",
      "Keep everything inside a frame.",
      "Arrange everything in a circle.",
      "Arrange everything in a single row.",
      "Stack the main elements vertically.",
      "Build the composition around one central object.",
      "Tuck one small item into an unexpected corner.",
      "Leave one corner mostly empty.",
      "Fill the composition edge to edge.",
      "Use only three main shapes.",
      "Repeat one shape exactly three times.",
      "Make the smallest object the focal point.",
      "Use one object as the anchor and build around it.",
      "Keep the whole composition off-center.",
      "Place the main object low in the composition.",
      "Place the main object high in the composition.",
      "Create a border around the outside edge.",
      "Divide the composition into two clear sections.",
      "Fit everything inside a contained shape.",
      "Repeat one motif in three sizes.",
      "Turn one motif into a border element.",
      "Use the same shape in at least three different ways.",
      "Echo one curved line throughout the composition.",
      "Echo one pointed shape throughout the composition.",
      "Build the prompt mostly from rounded shapes.",
      "Build the prompt mostly from angular shapes.",
      "Add one repeating filler shape between larger elements.",
      "Use one shape as a connector between other elements.",
      "Turn one object into a simplified icon.",
      "Make one motif face two different directions.",
      "Mirror one shape somewhere else in the composition.",
      "Use one repeated pattern on two separate objects.",
      "Add one stripe shape in an unexpected place.",
      "Make one object from stacked shapes only.",
      "Break one large shape into smaller pieces.",
      "Turn one small motif into a larger hero shape.",
      "Hide one repeated shape in plain sight.",
      "Use one scallop shape somewhere in the design.",
      "Use one arch shape at least twice.",
      "Use the lightest palette color for the largest area.",
      "Save the darkest palette color for the smallest details.",
      "Use one palette color only for outlines.",
      "Let one palette color dominate the composition.",
      "Keep one palette color almost untouched.",
      "Use the brightest palette color only once.",
      "Use one palette color for every repeated shape.",
      "Make the background a single palette color.",
      "Use one palette color only on the focal point.",
      "Use the warmest palette color for the smallest object.",
      "Use the coolest palette color for shadows or secondary details.",
      "Keep all details in just two of the palette colors.",
      "Make one color carry all the filler elements.",
      "Use one palette color in a very unexpected place.",
      "Make two objects share the same color treatment.",
      "Keep the main subject mostly monochromatic.",
      "Add a simple repeat pattern to one object only.",
      "Use one pattern on a background shape.",
      "Keep the pattern larger than usual.",
      "Keep the pattern very sparse.",
      "Alternate two motifs evenly.",
      "Add one filler motif between each larger motif.",
      "Use one motif as the hero and one as the filler.",
      "Rotate the same motif in different directions.",
      "Keep the pattern readable from far away.",
      "Build a border pattern instead of an all-over repeat.",
      "Use one shape as a checker replacement.",
      "Turn one motif into a stamp-like repeat.",
      "Keep one motif facing the same direction every time.",
      "Scatter the motifs loosely instead of evenly.",
      "Keep the spacing unusually tight.",
      "Keep the spacing unusually open.",
      "Use one tiny filler mark throughout the pattern.",
      "Make one motif noticeably larger than the others.",
      "Repeat one motif in a straight line.",
      "Create a tossed layout with only three motif types.",
      "Give the character one prop that helps tell the story.",
      "Put the character in work mode.",
      "Put the character in rest mode.",
      "Add one accessory that feels a little overdressed.",
      "Make the pose feel very formal.",
      "Make the pose feel extra relaxed.",
      "Give the character a tiny uniform detail.",
      "Let one object the character holds become a focal point.",
      "Repeat one shape from the character in a nearby prop.",
      "Make the character look busy without adding a full scene.",
      "Add one practical tool the character would actually use.",
      "Let the character interact with one oversize object.",
      "Keep the expression simple and readable.",
      "Make the silhouette the most interesting part.",
      "Use one repeated pattern in the character’s clothing or accessories.",
      "Give the character one object to carry, balance, push, or pull.",
      "Add one hanging detail.",
      "Add one object on a shelf or ledge.",
      "Include one framed detail in the scene.",
      "Use one repeating textile pattern.",
      "Add one plant or botanical shape somewhere in the composition.",
      "Let one object cast a very obvious shadow shape.",
      "Keep the background simple and flat.",
      "Include one small object that suggests daily life.",
      "Add one patterned surface and keep the rest quiet.",
      "Use one window, doorway, or arch to contain the scene.",
      "Make the scene feel collected, not crowded.",
      "Add one soft object and one hard object.",
      "Tuck one item partly behind another.",
      "Include one tiny sign, label, or title area.",
      "Let one object hang, lean, or drape.",
      "Build the scene around one surface like a table, shelf, or sill.",
      "Include three related items and one odd one out.",
      "Add one title area and one subtitle area.",
      "Build the page around one hero panel.",
      "Keep one section much busier than the others.",
      "Use one repeated label shape.",
      "Add one icon or symbol that appears more than once.",
      "Create a clear top, middle, and bottom section.",
      "Use one border treatment throughout the page.",
      "Let one item break the grid slightly.",
      "Add one callout area.",
      "Repeat one decorative divider shape.",
      "Include one boxed-off section.",
      "Make one panel feel like a close-up.",
      "Keep one element oversized for emphasis.",
      "Use one tiny filler shape to unify the whole page.",
      "Include one object shown from a different angle than the rest.",
      "Use only side-view shapes.",
      "Use only front-facing shapes.",
      "Add one stitched edge somewhere unexpected.",
      "Give one object a scalloped outline.",
      "Let one object tilt while the others stay straight.",
      "Add one repeating dot cluster.",
      "Use one repeated shadow color across the whole piece.",
      "Make one object overlap a border.",
      "Use one motif as a corner detail in two places.",
      "Add one object that feels tucked away."
    ]
  },
  "pools": {
    "actions": [
      "Draw",
      "Illustrate",
      "Design",
      "Create"
    ],
    "quickObjects": [
      {
        "name": "acorn",
        "category": "botanical",
        "article": "an"
      },
      {
        "name": "alleyway",
        "category": "place",
        "article": "an"
      },
      {
        "name": "anchor",
        "category": "travel",
        "article": "an"
      },
      {
        "name": "anemone",
        "category": "botanical",
        "article": "an"
      },
      {
        "name": "apple",
        "category": "kitchen",
        "article": "an"
      },
      {
        "name": "arch",
        "category": "motif",
        "article": "an"
      },
      {
        "name": "arched frame",
        "category": "motif",
        "article": "an"
      },
      {
        "name": "arched window",
        "category": "place",
        "article": "an"
      },
      {
        "name": "armchair",
        "category": "cozy",
        "article": "an"
      },
      {
        "name": "art supply shop",
        "category": "place",
        "article": "an"
      },
      {
        "name": "attic window",
        "category": "place",
        "article": "an"
      },
      {
        "name": "backpack",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "badge",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "badger",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "baguette",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "bakery counter",
        "category": "place",
        "article": "a"
      },
      {
        "name": "bakery window",
        "category": "place",
        "article": "a"
      },
      {
        "name": "balcony",
        "category": "place",
        "article": "a"
      },
      {
        "name": "barrel",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "bat",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "bay window",
        "category": "place",
        "article": "a"
      },
      {
        "name": "beach bucket",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "beach chair",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "beach umbrella",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "bear",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "bee",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "beetle",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "bell",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "berry",
        "category": "botanical",
        "article": "a",
        "plural": "berries"
      },
      {
        "name": "berry basket",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "berry stem",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "bicycle",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "binoculars",
        "category": "travel"
      },
      {
        "name": "bird",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "birdhouse",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "blooming branch",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "boat house",
        "category": "place",
        "article": "a"
      },
      {
        "name": "bookmark",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "bookshelf",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "bookshop",
        "category": "place",
        "article": "a"
      },
      {
        "name": "bow",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "branch",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "bread basket",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "breakfast tray",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "bridge",
        "category": "place",
        "article": "a"
      },
      {
        "name": "brush jar",
        "category": "art",
        "article": "a"
      },
      {
        "name": "bundt cake",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "buoy",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "bus stop",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "butter dish",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "butterfly",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "button",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "cabin",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "cactus",
        "category": "botanical",
        "plural": "cacti"
      },
      {
        "name": "cake slice",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "cake stand",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "cameo",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "camera",
        "category": "art",
        "article": "a"
      },
      {
        "name": "camp mug",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "camper van",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "campfire",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "candle",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "canoe",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "carousel",
        "category": "place",
        "article": "a"
      },
      {
        "name": "carousel horse",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "carrot bunch",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "cat",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "caterpillar",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "chair",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "chamomile",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "charm",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "checker tile",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "cherry",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "chicken",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "chipmunk",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "cinnamon roll",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "clock",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "cloud",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "clover",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "cobblestone path",
        "category": "place",
        "article": "a"
      },
      {
        "name": "cocoa mug",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "coffee pot",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "color wheel",
        "category": "art",
        "article": "a"
      },
      {
        "name": "colored pencil bundle",
        "category": "art",
        "article": "a"
      },
      {
        "name": "comet",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "compass",
        "category": "travel"
      },
      {
        "name": "coral",
        "category": "motif"
      },
      {
        "name": "cosmos",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "cottage",
        "category": "place",
        "article": "a"
      },
      {
        "name": "courtyard",
        "category": "place",
        "article": "a"
      },
      {
        "name": "cow",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "crab",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "crest",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "croissant",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "crow",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "crown",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "cupcake",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "daisy",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "dandelion",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "deer",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "diamond",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "dip pen",
        "category": "art",
        "article": "a"
      },
      {
        "name": "dog",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "doghouse",
        "category": "place",
        "article": "a"
      },
      {
        "name": "domino",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "donkey",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "doorway",
        "category": "place",
        "article": "a"
      },
      {
        "name": "dragonfly",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "duck",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "embroidery hoop",
        "category": "motif",
        "article": "an"
      },
      {
        "name": "envelope",
        "category": "paper",
        "article": "an"
      },
      {
        "name": "eucalyptus stem",
        "category": "botanical",
        "article": "an"
      },
      {
        "name": "fairy door",
        "category": "place",
        "article": "a"
      },
      {
        "name": "fallen leaf",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "fan shape",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "feather",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "fern",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "ferry",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "fig",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "firefly",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "fireplace",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "fish",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "floor lamp",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "floral frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "flour sack",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "flower",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "flower cart",
        "category": "place",
        "article": "a"
      },
      {
        "name": "flower stand",
        "category": "place",
        "article": "a"
      },
      {
        "name": "flower stem",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "food cart",
        "category": "place",
        "article": "a"
      },
      {
        "name": "forest path",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "fountain pen",
        "category": "art",
        "article": "a"
      },
      {
        "name": "fox",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "frog",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "front stoop",
        "category": "place",
        "article": "a"
      },
      {
        "name": "fruit tart",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "garden basket",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "garden gate",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "garden gloves",
        "category": "botanical"
      },
      {
        "name": "garden path",
        "category": "place",
        "article": "a"
      },
      {
        "name": "garden shed",
        "category": "place",
        "article": "a"
      },
      {
        "name": "garlic bulb",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "gift tag",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "goat",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "goose",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "greenhouse",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "greeting card",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "hanging plant",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "heart",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "hedgehog",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "herb bundle",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "hiking boots",
        "category": "travel"
      },
      {
        "name": "hill",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "honey jar",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "horse",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "hot air balloon",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "house",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "houseplant",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "ink bottle",
        "category": "art",
        "article": "an"
      },
      {
        "name": "iris",
        "category": "botanical"
      },
      {
        "name": "ivy",
        "category": "botanical",
        "article": "an"
      },
      {
        "name": "jam jar",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "jam tart",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "jellyfish",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "jewelry box",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "kettle",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "key",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "kite",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "label frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "ladybug",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "lamp",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "lantern",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "laundry basket",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "lavender sprig",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "leaf",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "leafy wreath",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "lemon",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "lemon slice",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "lemonade stand",
        "category": "place",
        "article": "a"
      },
      {
        "name": "library card",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "library cart",
        "category": "place",
        "article": "a"
      },
      {
        "name": "library nook",
        "category": "place",
        "article": "a"
      },
      {
        "name": "lichen patch",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "life preserver",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "lighthouse",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "little house",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "little vase",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "llama",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "loaf of bread",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "locket",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "love letter",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "luggage tag",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "macaron",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "madeleine",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "mantel",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "map",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "maple leaf",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "marigold",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "marker trio",
        "category": "art",
        "article": "a"
      },
      {
        "name": "market stall",
        "category": "place",
        "article": "a"
      },
      {
        "name": "matchbox",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "measuring cup",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "milk bottle",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "mirror",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "mole",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "monstera leaf",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "moon",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "moth",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "mountain",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "mountain cabin",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "mouse",
        "category": "animal",
        "article": "a",
        "plural": "mice"
      },
      {
        "name": "mushroom",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "mushroom house",
        "category": "place",
        "article": "a"
      },
      {
        "name": "nest",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "nesting doll",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "newsstand",
        "category": "place",
        "article": "a"
      },
      {
        "name": "oak leaf",
        "category": "botanical",
        "article": "an"
      },
      {
        "name": "octopus",
        "category": "animal"
      },
      {
        "name": "ogee shape",
        "category": "motif",
        "article": "an"
      },
      {
        "name": "olive branch",
        "category": "botanical",
        "article": "an"
      },
      {
        "name": "olive jar",
        "category": "kitchen",
        "article": "an"
      },
      {
        "name": "otter",
        "category": "animal",
        "article": "an"
      },
      {
        "name": "oval frame",
        "category": "motif",
        "article": "an"
      },
      {
        "name": "owl",
        "category": "animal",
        "article": "an"
      },
      {
        "name": "paddle",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "paint cup",
        "category": "art",
        "article": "a"
      },
      {
        "name": "paint palette",
        "category": "art",
        "article": "a"
      },
      {
        "name": "paint tube",
        "category": "art",
        "article": "a"
      },
      {
        "name": "paintbrush",
        "category": "art",
        "article": "a"
      },
      {
        "name": "painted egg",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "palm leaf",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "pancakes",
        "category": "kitchen"
      },
      {
        "name": "pansy",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "pantry shelf",
        "category": "place",
        "article": "a"
      },
      {
        "name": "paper doll",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "paper lantern",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "passport",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "patch",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "peach",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "pear",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "pelican",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "pencil",
        "category": "art",
        "article": "a"
      },
      {
        "name": "pendant",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "pennant",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "peony",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "pickle jar",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "picnic basket",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "picnic blanket",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "picnic table",
        "category": "place",
        "article": "a"
      },
      {
        "name": "picture frame",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "pie",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "pig",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "pigeon",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "pin cushion",
        "category": "art",
        "article": "a"
      },
      {
        "name": "pine branch",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "pinecone",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "plant marker",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "plant pot",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "plant shop",
        "category": "place",
        "article": "a"
      },
      {
        "name": "playing card",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "pony",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "poppy",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "porch step",
        "category": "place",
        "article": "a"
      },
      {
        "name": "porch swing",
        "category": "place",
        "article": "a"
      },
      {
        "name": "post office",
        "category": "place",
        "article": "a"
      },
      {
        "name": "postage stamp",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "postage stamp frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "postcard",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "potting bench",
        "category": "place",
        "article": "a"
      },
      {
        "name": "pressed flower",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "pretzel",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "produce stand",
        "category": "place",
        "article": "a"
      },
      {
        "name": "pruning shears",
        "category": "botanical"
      },
      {
        "name": "puddle",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "puffin",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "quilt block",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "quilt block frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "rabbit",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "raccoon",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "radish bunch",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "rain cloud",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "rainbow",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "raindrop",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "ranunculus",
        "category": "botanical"
      },
      {
        "name": "reading nook",
        "category": "place",
        "article": "a"
      },
      {
        "name": "recipe card",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "record player",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "ribbon",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "ribbon frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "road sign",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "robin",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "rocking chair",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "rolling pin",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "rowboat",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "sailboat",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "sandcastle",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "scallop",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "scallop frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "scissors",
        "category": "art"
      },
      {
        "name": "scone",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "seahorse",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "seal",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "seaside cottage",
        "category": "place",
        "article": "a"
      },
      {
        "name": "seaweed",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "seed packet",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "seed pod",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "seed tray",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "sheep",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "shell",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "shop window",
        "category": "place",
        "article": "a"
      },
      {
        "name": "ski lift",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "snail",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "snail shell",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "snake",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "snow globe",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "snowflake",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "soup bowl",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "sparrow",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "spice jar",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "spinning top",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "spiral",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "spoon",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "sprig",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "squirrel",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "star",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "starburst",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "station clock",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "sticker sheet",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "strawberry",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "strawberry basket",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "studio desk",
        "category": "place",
        "article": "a"
      },
      {
        "name": "succulent",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "sugar bowl",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "sugar jar",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "suitcase",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "sun",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "sunburst frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "sunflower",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "swan",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "syrup bottle",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "tartlet",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "tea stand",
        "category": "place",
        "article": "a"
      },
      {
        "name": "tea tin",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "teacup",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "teacup and saucer",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "teapot",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "teardrop",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "tent",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "terracotta pot",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "thermos",
        "category": "travel"
      },
      {
        "name": "thistle",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "ticket booth",
        "category": "place",
        "article": "a"
      },
      {
        "name": "ticket frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "ticket stub",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "tide pool",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "tomato",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "tool shed",
        "category": "place",
        "article": "a"
      },
      {
        "name": "toy block",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "trading card",
        "category": "paper",
        "article": "a"
      },
      {
        "name": "trail sign",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "train car",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "train platform",
        "category": "place",
        "article": "a"
      },
      {
        "name": "train ticket",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "travel trunk",
        "category": "travel",
        "article": "a"
      },
      {
        "name": "tree",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "tree stump",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "treehouse",
        "category": "place",
        "article": "a"
      },
      {
        "name": "tulip",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "turtle",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "twig bundle",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "vine",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "vine frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "waffle",
        "category": "kitchen",
        "article": "a"
      },
      {
        "name": "wall shelf",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "watering can",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "wave",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "whale",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "wheelbarrow",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "wildflower",
        "category": "botanical",
        "article": "a"
      },
      {
        "name": "window",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "window box",
        "category": "place",
        "article": "a"
      },
      {
        "name": "window display",
        "category": "place",
        "article": "a"
      },
      {
        "name": "window frame",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "worm",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "wreath",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "yarn ball",
        "category": "art",
        "article": "a"
      },
      {
        "name": "harp",
        "category": "art",
        "article": "a"
      },
      {
        "name": "piano",
        "category": "art",
        "article": "a"
      },
      {
        "name": "flute",
        "category": "art",
        "article": "a"
      },
      {
        "name": "drumset",
        "category": "art",
        "article": "a"
      },
      {
        "name": "accordion",
        "category": "art",
        "article": "an"
      },
      {
        "name": "cuckoo clock",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "doll",
        "category": "cozy",
        "article": "a"
      },
      {
        "name": "cat eye glasses",
        "category": "cozy",
        "article": "some"
      },
      {
        "name": "boots",
        "category": "travel",
        "article": "some"
      },
      {
        "name": "ballet shoes",
        "category": "travel",
        "article": "some"
      },
      {
        "name": "bubbles",
        "category": "motif"
      },
      {
        "name": "constellation",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "puppet",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "museum",
        "category": "place",
        "article": "a"
      },
      {
        "name": "circus tent",
        "category": "place",
        "article": "a"
      },
      {
        "name": "apothecary",
        "category": "place",
        "article": "an"
      },
      {
        "name": "hare",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "field mouse",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "fawn",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "black bear",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "beaver",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "possum",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "skunk",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "weasel",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "ferret",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "wolf",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "coyote",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "bobcat",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "lynx",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "songbird",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "wren",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "finch",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "bluebird",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "chickadee",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "swallow",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "dove",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "raven",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "magpie",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "barn owl",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "hawk",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "heron",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "egret",
        "category": "animal",
        "article": "an"
      },
      {
        "name": "crane",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "seagull",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "toad",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "newt",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "salamander",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "slug",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "bumblebee",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "grasshopper",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "cricket",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "spider",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "kitten",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "puppy",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "lamb",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "calf",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "piglet",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "rooster",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "hen",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "chick",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "turkey",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "duckling",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "gnome",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "elf",
        "category": "animal",
        "article": "an"
      },
      {
        "name": "fairy",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "sprite",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "pixie",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "mermaid",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "sea witch",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "selkie",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "sea nymph",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "water sprite",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "unicorn",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "narwhal",
        "category": "animal",
        "article": "a"
      },
      {
        "name": "pirate",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "sailor",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "fisherman",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "clam digger",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "beachcomber",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "witch",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "wizard",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "magician",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "fortune teller",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "alchemist",
        "category": "motif",
        "article": "an"
      },
      {
        "name": "herbalist",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "spellmaker",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "princess",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "prince",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "queen",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "king",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "knight",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "jester",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "farmer",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "shepherd",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "milkman",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "dancer",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "nurse",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "puppeteer",
        "category": "motif",
        "article": "a"
      },
      {
        "name": "acrobat",
        "category": "motif",
        "article": "an"
      },
      {
        "name": "fire dancer",
        "category": "motif",
        "article": "a"
      }
    ],
    "quickDetails": {
      "art": [
        "a painted stripe",
        "a band of dots",
        "a wrapped handle",
        "a cap detail",
        "a clipped edge",
        "an unexpected shadow shape",
        "a repeated brush mark"
      ],
      "paper": [
        "a border pattern",
        "a folded edge",
        "a stamp corner",
        "a scalloped edge",
        "a patterned liner",
        "a framed center"
      ],
      "cozy": [
        "a patterned surface",
        "a scalloped edge",
        "a floral detail",
        "a repeating textile motif",
        "a curved shadow shape",
        "a layered border"
      ],
      "kitchen": [
        "a patterned rim",
        "a repeating garnish shape",
        "a striped surface",
        "a decorated edge",
        "a repeating mark",
        "a little shadow pool"
      ],
      "botanical": [
        "petal shapes",
        "leaf shapes",
        "seed details",
        "a repeating vein pattern",
        "a curved stem",
        "a clustered center"
      ],
      "animal": [
        "wing markings",
        "tail shapes",
        "shell details",
        "spot patterns",
        "a simple accessory",
        "an unexpected silhouette detail"
      ],
      "travel": [
        "a stitched edge",
        "a map detail",
        "a striped band",
        "a window shape",
        "a hanging tag",
        "a route line"
      ],
      "place": [
        "a striped awning",
        "a window detail",
        "a repeating tile",
        "a doorway arch",
        "a row of little panes",
        "a hanging sign"
      ],
      "motif": [
        "a repeating pattern",
        "a scalloped edge",
        "a layered center",
        "a stamped look",
        "a border treatment",
        "a second echo shape"
      ],
      "default": [
        "a repeating detail",
        "a simple border",
        "a strong silhouette detail"
      ]
    },
    "quickChallenges": [
      "Use the lightest palette color for the largest area",
      "Save the darkest palette color for the smallest details",
      "Use one palette color only for outlines",
      "Make the background a single palette color",
      "Repeat one shape exactly three times",
      "Let one color show up only once",
      "Make one small detail the focal point",
      "Turn one repeated shape into a border"
    ],
    "cozyScenes": [
      {
        "setting": "reading nook",
        "addOns": [
          "book stack",
          "blanket",
          "lamp"
        ],
        "constraints": [
          "Include one framed detail.",
          "Keep the background simple and flat.",
          "Add one soft object and one hard object."
        ]
      },
      {
        "setting": "studio desk",
        "addOns": [
          "brush jar",
          "paint palette",
          "paper stack"
        ],
        "constraints": [
          "Build the scene around one surface.",
          "Tuck one item partly behind another.",
          "Include one small object that suggests daily life."
        ]
      },
      {
        "setting": "pantry shelf",
        "addOns": [
          "jam jar",
          "tea tin",
          "bread basket"
        ],
        "constraints": [
          "Use one repeating textile pattern.",
          "Keep the scene collected, not crowded.",
          "Add one patterned surface and keep the rest quiet."
        ]
      },
      {
        "setting": "windowsill",
        "addOns": [
          "houseplant",
          "little vase",
          "teacup"
        ],
        "constraints": [
          "Add one plant shape somewhere in the composition.",
          "Let one object cast an obvious shadow shape.",
          "Use one window or arch to contain the scene."
        ]
      },
      {
        "setting": "breakfast tray",
        "addOns": [
          "teacup",
          "jam jar",
          "croissant"
        ],
        "constraints": [
          "Keep one object oversized for emphasis.",
          "Include one framed detail.",
          "Add one repeating textile pattern."
        ]
      },
      {
        "setting": "fireplace mantel",
        "addOns": [
          "candle",
          "picture frame",
          "little vase"
        ],
        "constraints": [
          "Create a clear top, middle, and bottom section.",
          "Keep the background simple and flat.",
          "Let one object lean or drape."
        ]
      },
      {
        "setting": "greenhouse corner",
        "addOns": [
          "terracotta pot",
          "watering can",
          "garden gloves"
        ],
        "constraints": [
          "Add one hanging detail.",
          "Use one repeating plant shape.",
          "Make the scene feel collected, not crowded."
        ]
      },
      {
        "setting": "bookshop window",
        "addOns": [
          "book stack",
          "greeting card",
          "hanging sign"
        ],
        "constraints": [
          "Use one window or frame to contain the scene.",
          "Include one title area.",
          "Let one item break the grid slightly."
        ]
      },
      {
        "setting": "flower stand",
        "addOns": [
          "flower bucket",
          "bouquet wrap",
          "price card"
        ],
        "constraints": [
          "Add one patterned surface and keep the rest quiet.",
          "Build the scene around one surface.",
          "Include one small sign area."
        ]
      },
      {
        "setting": "tea table",
        "addOns": [
          "teapot",
          "teacup and saucer",
          "cake slice"
        ],
        "constraints": [
          "Keep one section busier than the others.",
          "Tuck one item partly behind another.",
          "Use one repeated textile pattern."
        ]
      },
      {
        "setting": "porch step",
        "addOns": [
          "watering can",
          "plant pot",
          "lantern"
        ],
        "constraints": [
          "Add one hard object and one soft object.",
          "Include one framed detail.",
          "Use one arch or doorway nearby."
        ]
      },
      {
        "setting": "record corner",
        "addOns": [
          "record player",
          "bookshelf",
          "floor lamp"
        ],
        "constraints": [
          "Keep the composition off-center.",
          "Let one object cast an obvious shadow shape.",
          "Include one small daily-life object."
        ]
      },
      {
        "setting": "garden shelf",
        "addOns": [
          "seed packet",
          "plant marker",
          "pruning shears"
        ],
        "constraints": [
          "Add one hanging detail.",
          "Use one repeated label shape.",
          "Keep the background simple and flat."
        ]
      },
      {
        "setting": "window display",
        "addOns": [
          "greeting card",
          "little vase"
        ],
        "constraints": [
          "Build the scene around one hero object.",
          "Include one boxed-off section.",
          "Let one item overlap a frame."
        ]
      },
      {
        "setting": "cozy kitchen counter",
        "addOns": [
          "flour sack",
          "teacup",
          "little vase"
        ],
        "constraints": [
          "Keep one patterned surface and the rest quiet.",
          "Include one small object that suggests daily life.",
          "Use one shadow color across the piece."
        ]
      },
      {
        "setting": "rainy window seat",
        "addOns": [
          "teacup",
          "book stack",
          "puddle-shaped shadow"
        ],
        "constraints": [
          "Use one window or arch to contain the scene.",
          "Keep the background simple and flat.",
          "Let one object cast a very obvious shadow shape."
        ]
      },
      {
        "setting": "attic corner",
        "addOns": [
          "music box",
          "paper crown",
          "little trunk"
        ],
        "constraints": [
          "Make the scene feel collected, not crowded.",
          "Tuck one item partly behind another.",
          "Add one title area or tiny label."
        ]
      },
      {
        "setting": "apothecary shelf",
        "addOns": [
          "herb bundle",
          "tiny jar",
          "moon label"
        ],
        "constraints": [
          "Include one boxed-off section.",
          "Use one repeated label shape.",
          "Keep one corner mostly empty."
        ]
      },
      {
        "setting": "puppet theater corner",
        "addOns": [
          "puppet",
          "stage curtain",
          "star garland"
        ],
        "constraints": [
          "Add one hanging detail.",
          "Let one item break the grid slightly.",
          "Make one panel feel like a close-up."
        ]
      },
      {
        "setting": "seaside porch",
        "addOns": [
          "shell",
          "rocking chair",
          "little bird"
        ],
        "constraints": [
          "Include one plant or botanical shape somewhere in the composition.",
          "Let one object lean or drape.",
          "Keep the scene soft and open."
        ]
      },
      {
        "setting": "farmer's table",
        "addOns": [
          "seed packet",
          "milk bottle",
          "sunflower"
        ],
        "constraints": [
          "Build the scene around one surface.",
          "Add one patterned surface and keep the rest quiet.",
          "Include three related items and one odd one out."
        ]
      },
      {
        "setting": "moonlit garden bench",
        "addOns": [
          "lantern",
          "moth",
          "flower pot"
        ],
        "constraints": [
          "Use the darkest palette color for the smallest details.",
          "Add one plant shape somewhere in the composition.",
          "Make the smallest object the focal point."
        ]
      },
      {
        "setting": "cottage entryway",
        "addOns": [
          "boots",
          "flower basket",
          "little key"
        ],
        "constraints": [
          "Use one doorway or arch to contain the scene.",
          "Add one soft object and one hard object.",
          "Let one item sit partly off-center."
        ]
      },
      {
        "setting": "tiny greenhouse shelf",
        "addOns": [
          "seed tray",
          "plant marker",
          "terracotta pot"
        ],
        "constraints": [
          "Repeat one shape exactly three times.",
          "Keep the spacing unusually tight.",
          "Use one repeated label shape."
        ]
      },
      {
        "setting": "music room corner",
        "addOns": [
          "harp",
          "record player",
          "little vase"
        ],
        "constraints": [
          "Make one object oversized for emphasis.",
          "Add one framed detail.",
          "Echo one curved line throughout the composition."
        ]
      },
      {
        "setting": "well-loved sewing basket",
        "addOns": [
          "pin cushion",
          "ribbon",
          "scissors"
        ],
        "constraints": [
          "Use one repeated textile pattern.",
          "Let one object hang, lean, or drape.",
          "Keep the composition off-center."
        ]
      },
      {
        "setting": "little museum display",
        "addOns": [
          "tiny frame",
          "label",
          "shell"
        ],
        "constraints": [
          "Include one boxed-off section.",
          "Create a clear top, middle, and bottom section.",
          "Use one repeated frame shape."
        ]
      },
      {
        "setting": "witchy kitchen shelf",
        "addOns": [
          "potion bottle",
          "herb bundle",
          "moon charm"
        ],
        "constraints": [
          "Use one palette color in a very unexpected place.",
          "Tuck one item partly behind another.",
          "Make the scene feel collected, not crowded."
        ]
      },
      {
        "setting": "breakfast nook",
        "addOns": [
          "pancakes",
          "syrup bottle",
          "little flower"
        ],
        "constraints": [
          "Keep one object oversized for emphasis.",
          "Use one repeating pattern on a surface.",
          "Build the scene around one central object."
        ]
      },
      {
        "setting": "grandma-chic mantel",
        "addOns": [
          "cuckoo clock",
          "little vase",
          "framed flower"
        ],
        "constraints": [
          "Include one framed detail.",
          "Use one tiny filler shape to unify the whole page.",
          "Keep the pattern sparse."
        ]
      },
      {
        "setting": "grandpa-chic desk",
        "addOns": [
          "record player",
          "mug",
          "little calendar"
        ],
        "constraints": [
          "Build the scene around one surface.",
          "Add one practical object.",
          "Let one object overlap the edge of the composition."
        ]
      },
      {
        "setting": "fairytale reading nook",
        "addOns": [
          "crown",
          "open book",
          "mushroom lamp"
        ],
        "constraints": [
          "Use one arch shape at least twice.",
          "Make one small detail the focal point.",
          "Keep everything inside a frame."
        ]
      },
      {
        "setting": "sunny potting bench",
        "addOns": [
          "plant pot",
          "seed packet",
          "garden gloves"
        ],
        "constraints": [
          "Use the brightest palette color only once.",
          "Repeat one motif in three sizes.",
          "Add one hanging detail."
        ]
      },
      {
        "setting": "coastal studio shelf",
        "addOns": [
          "paint tube",
          "shell",
          "postcard"
        ],
        "constraints": [
          "Use one motif as a corner detail in two places.",
          "Keep the scene collected, not crowded.",
          "Add one framed detail."
        ]
      },
      {
        "setting": "tiny bakery window",
        "addOns": [
          "cake slice",
          "croissant",
          "little sign"
        ],
        "constraints": [
          "Use one window or arch to contain the scene.",
          "Add one repeating filler shape.",
          "Let one object tilt while the others stay straight."
        ]
      }
    ],
    "fullFormats": [
      {
        "format": "field guide",
        "subject": "garden moths",
        "pieces": [
          "3 varied specimens",
          "a title area",
          "one small divider shape"
        ]
      },
      {
        "format": "sticker sheet",
        "subject": "cozy kitchen objects",
        "pieces": [
          "6 to 8 stickers",
          "one small filler motif",
          "a simple border"
        ]
      },
      {
        "format": "postcard set",
        "subject": "mini travel scenes",
        "pieces": [
          "3 distinct cards",
          "one border system",
          "a shared color story"
        ]
      },
      {
        "format": "label set",
        "subject": "jam jars",
        "pieces": [
          "3 label shapes",
          "one repeated motif",
          "a small title area"
        ]
      },
      {
        "format": "mini travel poster",
        "subject": "lighthouse coast",
        "pieces": [
          "one hero landmark",
          "a bold title area",
          "a simple border"
        ]
      },
      {
        "format": "recipe card",
        "subject": "cinnamon rolls",
        "pieces": [
          "one title area",
          "3 supporting icons",
          "a patterned border"
        ]
      },
      {
        "format": "menu board",
        "subject": "tea stand specials",
        "pieces": [
          "one heading",
          "3 menu items",
          "one divider treatment"
        ]
      },
      {
        "format": "shop window",
        "subject": "a paper goods display",
        "pieces": [
          "one hero object",
          "3 supporting items",
          "a small sign area"
        ]
      },
      {
        "format": "window display",
        "subject": "a flower shop",
        "pieces": [
          "one central display",
          "2 layered props",
          "a title area"
        ]
      },
      {
        "format": "map",
        "subject": "a small market district",
        "pieces": [
          "3 landmarks",
          "one path",
          "a simple legend"
        ]
      },
      {
        "format": "market map",
        "subject": "a garden fair",
        "pieces": [
          "4 stall icons",
          "one route line",
          "a title area"
        ]
      },
      {
        "format": "book cover",
        "subject": "a cozy field notebook",
        "pieces": [
          "one framed motif",
          "a title area",
          "a simple border"
        ]
      },
      {
        "format": "greeting card",
        "subject": "a botanical hello",
        "pieces": [
          "one focal motif",
          "a title area",
          "a border treatment"
        ]
      },
      {
        "format": "packaging label",
        "subject": "tea tins",
        "pieces": [
          "one central motif",
          "a title area",
          "a repeated border shape"
        ]
      },
      {
        "format": "stamp set",
        "subject": "garden finds",
        "pieces": [
          "4 stamp designs",
          "one shared frame shape",
          "a tiny divider motif"
        ]
      },
      {
        "format": "illustrated checklist",
        "subject": "studio essentials",
        "pieces": [
          "5 checklist items",
          "one icon repeated twice",
          "a title area"
        ]
      },
      {
        "format": "supply guide",
        "subject": "watercolor tools",
        "pieces": [
          "4 labeled tools",
          "one tip box",
          "a title area"
        ]
      },
      {
        "format": "tiny zine page",
        "subject": "a snail post office",
        "pieces": [
          "one hero panel",
          "one title area",
          "one divider shape"
        ]
      },
      {
        "format": "poster set",
        "subject": "seasonal produce",
        "pieces": [
          "3 related posters",
          "one shared border system",
          "one repeated icon"
        ]
      },
      {
        "format": "camp badge",
        "subject": "forest trail club",
        "pieces": [
          "one badge shape",
          "2 supporting motifs",
          "a title area"
        ]
      },
      {
        "format": "enamel pin set",
        "subject": "cozy desk bits",
        "pieces": [
          "5 pins",
          "one filler motif",
          "a backing card"
        ]
      },
      {
        "format": "tea tin label",
        "subject": "wildflower blend",
        "pieces": [
          "one hero floral motif",
          "a title area",
          "a border pattern"
        ]
      },
      {
        "format": "jar label",
        "subject": "peach jam",
        "pieces": [
          "one central fruit motif",
          "a title area",
          "a small border"
        ]
      },
      {
        "format": "recipe booklet cover",
        "subject": "small-batch baking",
        "pieces": [
          "one framed motif",
          "a title area",
          "a subtitle area"
        ]
      },
      {
        "format": "illustrated menu",
        "subject": "a breakfast café",
        "pieces": [
          "4 menu items",
          "one border treatment",
          "one hero panel"
        ]
      },
      {
        "format": "garden marker set",
        "subject": "kitchen herbs",
        "pieces": [
          "4 marker shapes",
          "one repeated motif",
          "a title area"
        ]
      },
      {
        "format": "calendar page",
        "subject": "garden chores",
        "pieces": [
          "one main illustration",
          "one date grid",
          "one notes box"
        ]
      },
      {
        "format": "tote bag graphic",
        "subject": "art supplies",
        "pieces": [
          "one central icon cluster",
          "one title area",
          "one border detail"
        ]
      },
      {
        "format": "t-shirt graphic",
        "subject": "camp mug and lantern",
        "pieces": [
          "one hero motif",
          "one supporting shape",
          "one title curve"
        ]
      },
      {
        "format": "wrapping paper layout",
        "subject": "bows and ribbons",
        "pieces": [
          "one hero motif",
          "2 filler motifs",
          "one repeating mark"
        ]
      },
      {
        "format": "postcard backside",
        "subject": "a garden postcard",
        "pieces": [
          "an address area",
          "one stamp box",
          "one simple divider"
        ]
      },
      {
        "format": "bookplate",
        "subject": "a home library",
        "pieces": [
          "one framed center",
          "one title area",
          "one repeated border mark"
        ]
      },
      {
        "format": "library card design",
        "subject": "a bird library",
        "pieces": [
          "one title area",
          "one decorative frame",
          "one small icon"
        ]
      },
      {
        "format": "field notes spread",
        "subject": "coastal finds",
        "pieces": [
          "3 observations",
          "one title area",
          "one divider treatment"
        ]
      },
      {
        "format": "color palette card",
        "subject": "autumn kitchen",
        "pieces": [
          "3 color swatches",
          "one title area",
          "one hero motif"
        ]
      },
      {
        "format": "storefront sign",
        "subject": "a plant shop",
        "pieces": [
          "one sign shape",
          "one border treatment",
          "one supporting icon"
        ]
      }
    ],
    "weirdObjectTransformations": [
      "teacup with a staircase inside",
      "lighthouse inside a jam jar",
      "boot that works as a shop",
      "suitcase full of windows",
      "kettle growing leaves",
      "paint tube growing flowers",
      "mailbox for butterflies",
      "lantern with roots",
      "mushroom with a front door",
      "teapot with a roof",
      "shell with a window",
      "chair with mushroom legs",
      "matchbox with a room inside",
      "soup bowl with a bridge across it",
      "open book with a garden inside",
      "clock with flower petals for numbers",
      "pear with a balcony",
      "jar with weather inside",
      "spoon with a scene in the bowl",
      "postcard shaped like a house",
      "acorn with a chimney",
      "clock with flower petals",
      "mushroom circus tent",
      "snail carriage",
      "bathtub galloping on horse legs",
      "loaf of bread wearing roller skates",
      "chair wearing shoes",
      "erupting cupcake",
      "paint tube squeezing out a snake",
      "trumpet blowing bubbles",
      "kite dragging the sky behind it",
      "moon melting into a teacup",
      "ladder walking away on tiny feet",
      "flower ringing like a bell",
      "teapot pouring stars",
      "candle casting a butterfly shadow",
      "house wearing rain boots",
      "fish swimming through wallpaper",
      "cloud sleeping in a suitcase",
      "carrot playing the trumpet",
      "mushroom holding up the moon",
      "slipper with windows",
      "cake slice with a drawbridge",
      "lantern full of tiny fish",
      "apple with a spiral staircase",
      "book flapping like a bird",
      "umbrella raining upward",
      "piano growing mushrooms",
      "cuckoo clock releasing bubbles",
      "accordion stretching into a bridge",
      "parasol with a tiny storm underneath",
      "chair growing antlers",
      "dollhouse floating like a balloon",
      "boots sprouting flower stems",
      "teacup sailing across a puddle",
      "sunflower wearing a tiny crown",
      "cottage with chicken legs",
      "harp with vines for strings",
      "record player spinning the moon",
      "paintbrush sweeping up stars",
      "shell opening into a theater"
    ],
    "weirdCreatureConditions": [
      "with a shell-shaped house",
      "carrying an object much too large",
      "sitting inside a teacup",
      "tucked into a postage stamp frame",
      "with window-shaped markings",
      "wearing a lampshade like a hat",
      "pulling a ribbon that becomes a path",
      "with flowers growing from its tail",
      "wearing a cake like a hat",
      "inside a matchbox",
      "under an umbrella made of leaves",
      "wearing a backpack shaped like a house",
      "with a little door on its back",
      "floating in a soup bowl like a boat",
      "carrying a lantern bigger than its body",
      "sitting on a stack of postage stamps",
      "holding a key larger than its head",
      "standing inside a picture frame",
      "standing on stilts made of pencils",
      "with a tail tied in a bow",
      "carrying a sleeping moon",
      "wearing a quilt like a cape",
      "with spots that look like moons",
      "with a shadow doing something different",
      "melting into a puddle of stars",
      "with horns made of smoke",
      "with a body that looks inflated",
      "wearing a cloud as a backpack",
      "with wings made of postage stamps",
      "balancing a tiny cottage on its head",
      "pulling a moon on a string",
      "with a belly full of tiny windows",
      "wearing rain boots on every foot",
      "holding a lantern full of fish",
      "with a crown made of mushrooms",
      "casting a shadow shaped like a different creature",
      "carrying a teacup bigger than its body",
      "wearing a collar of tiny stars",
      "with a staircase curling around its tail",
      "sleeping inside a flower",
      "with ears shaped like little moons",
      "painting the sky with a brush",
      "wearing a curtain like a cape",
      "with spots that turn into bubbles",
      "standing inside a tiny museum display",
      "dragging a puddle behind it",
      "holding an umbrella that grows leaves",
      "wearing a hat with a doorway in it",
      "floating inside a soap bubble",
      "with a tiny stage on its back",
      "carrying a basket of glowing acorns",
      "wearing ballet shoes on mismatched feet"
    ],
    "weirdPatternPrompts": [],
    "weirdCreatures": [
      "pigeon",
      "snail",
      "bee",
      "butterfly",
      "frog",
      "rabbit",
      "fox",
      "owl",
      "hedgehog",
      "turtle",
      "cat",
      "dog",
      "duck",
      "mouse",
      "squirrel",
      "raccoon",
      "otter",
      "crab",
      "fish",
      "moth",
      "goose",
      "swan",
      "badger",
      "deer",
      "bear",
      "bat",
      "seal",
      "whale",
      "seahorse",
      "octopus",
      "jellyfish",
      "ladybug",
      "beetle",
      "dragonfly",
      "firefly",
      "caterpillar",
      "worm",
      "mole",
      "chipmunk",
      "sparrow",
      "robin",
      "crow",
      "pelican",
      "puffin",
      "sheep",
      "goat",
      "llama",
      "pony",
      "donkey",
      "chicken",
      "cow",
      "pig",
      "snake",
      "hare",
      "field mouse",
      "fawn",
      "black bear",
      "beaver",
      "possum",
      "skunk",
      "weasel",
      "ferret",
      "wolf",
      "coyote",
      "bobcat",
      "lynx",
      "songbird",
      "wren",
      "finch",
      "bluebird",
      "chickadee",
      "swallow",
      "dove",
      "raven",
      "magpie",
      "barn owl",
      "hawk",
      "heron",
      "egret",
      "crane",
      "seagull",
      "toad",
      "newt",
      "salamander",
      "slug",
      "bumblebee",
      "grasshopper",
      "cricket",
      "spider",
      "kitten",
      "puppy",
      "lamb",
      "calf",
      "horse",
      "piglet",
      "rooster",
      "hen",
      "chick",
      "turkey",
      "duckling",
      "gnome",
      "elf",
      "fairy",
      "sprite",
      "pixie",
      "mermaid",
      "sea witch",
      "selkie",
      "sea nymph",
      "water sprite",
      "unicorn",
      "narwhal"
    ],
    "patternPrompts": [
      {
        "action": "Create",
        "format": "repeat pattern",
        "motifs": [
          "bows",
          "ribbons",
          "keys"
        ],
        "constraint": "Keep one motif noticeably larger than the others."
      },
      {
        "action": "Design",
        "format": "repeat pattern",
        "motifs": [
          "shells",
          "stars",
          "moons"
        ],
        "constraint": "Use one tiny filler mark throughout the pattern."
      },
      {
        "action": "Create",
        "format": "border pattern",
        "motifs": [
          "teacups",
          "spoons",
          "cake slices"
        ],
        "constraint": "Build a border pattern instead of an all-over repeat."
      },
      {
        "action": "Design",
        "format": "motif set",
        "motifs": [
          "postage stamps",
          "ticket stubs",
          "library cards"
        ],
        "constraint": "Use one repeated frame shape across the set."
      },
      {
        "action": "Create",
        "format": "repeat pattern",
        "motifs": [
          "wildflowers",
          "berries",
          "branches"
        ],
        "constraint": "Alternate two motifs evenly."
      },
      {
        "action": "Create",
        "format": "repeat pattern",
        "motifs": [
          "mushrooms",
          "snails",
          "lanterns"
        ],
        "constraint": "Scatter the motifs loosely instead of evenly."
      },
      {
        "action": "Design",
        "format": "sticker sheet",
        "motifs": [
          "garden gloves",
          "watering cans",
          "terracotta pots"
        ],
        "constraint": "Use one motif as the hero and one as the filler."
      },
      {
        "action": "Create",
        "format": "repeat pattern",
        "motifs": [
          "croissants",
          "jam jars",
          "tea tins"
        ],
        "constraint": "Repeat one motif in a straight line."
      },
      {
        "action": "Create",
        "format": "repeat pattern",
        "motifs": [
          "camp mugs",
          "lanterns",
          "trail signs"
        ],
        "constraint": "Keep the spacing unusually open."
      },
      {
        "action": "Design",
        "format": "motif set",
        "motifs": [
          "bookmarks",
          "gift tags",
          "greeting cards"
        ],
        "constraint": "Use one border treatment throughout the set."
      },
      {
        "action": "Create",
        "format": "repeat pattern",
        "motifs": [
          "butterflies",
          "moths",
          "dragonflies"
        ],
        "constraint": "Rotate the same motif in different directions."
      },
      {
        "action": "Design",
        "format": "repeat pattern",
        "motifs": [
          "birdhouses",
          "little houses",
          "arched windows"
        ],
        "constraint": "Use one arch shape at least twice."
      },
      {
        "action": "Create",
        "format": "repeat pattern",
        "motifs": [
          "strawberries",
          "lemons",
          "cherries"
        ],
        "constraint": "Make one motif noticeably larger than the others."
      },
      {
        "action": "Design",
        "format": "badge set",
        "motifs": [
          "camp badges",
          "compass roses",
          "trail signs"
        ],
        "constraint": "Keep one element oversized for emphasis."
      },
      {
        "action": "Design",
        "format": "motif set",
        "motifs": [
          "candles",
          "picture frames",
          "vases"
        ],
        "constraint": "Use one repeated shadow color across the whole piece."
      },
      {
        "action": "Create",
        "format": "border pattern",
        "motifs": [
          "waves",
          "seaweed",
          "coral"
        ],
        "constraint": "Repeat one motif in three sizes."
      },
      {
        "action": "Design",
        "format": "repeat pattern",
        "motifs": [
          "paint tubes",
          "ink bottles",
          "brushes"
        ],
        "constraint": "Use one palette color for all repeated shapes."
      },
      {
        "action": "Create",
        "format": "repeat pattern",
        "motifs": [
          "foxes",
          "owls",
          "rabbits"
        ],
        "constraint": "Keep the pattern readable from far away."
      },
      {
        "action": "Design",
        "format": "motif set",
        "motifs": [
          "teapots",
          "teacups and saucers",
          "jam tarts"
        ],
        "constraint": "Use one repeated pattern on two separate objects."
      },
      {
        "action": "Create",
        "format": "repeat pattern",
        "motifs": [
          "feathers",
          "leaves",
          "clouds"
        ],
        "constraint": "Keep the spacing unusually tight."
      },
      {
        "action": "Create",
        "format": "tossed repeat pattern",
        "motifs": [
          "ballet shoes",
          "stars",
          "ribbons"
        ],
        "constraint": "Keep one motif noticeably larger than the others."
      },
      {
        "action": "Design",
        "format": "border pattern",
        "motifs": [
          "boots",
          "wildflowers",
          "little moons"
        ],
        "constraint": "Let one motif overlap the border edge."
      },
      {
        "action": "Create",
        "format": "checkerboard-style repeat",
        "motifs": [
          "hearts",
          "flowers",
          "tiny houses"
        ],
        "constraint": "Use one motif as a checker replacement."
      },
      {
        "action": "Design",
        "format": "scattered repeat",
        "motifs": [
          "sunflowers",
          "bees",
          "ribbons"
        ],
        "constraint": "Hide one tiny surprise motif in the layout."
      },
      {
        "action": "Create",
        "format": "symmetrical folk repeat",
        "motifs": [
          "birds",
          "branches",
          "stars"
        ],
        "constraint": "Mirror one shape somewhere else in the composition."
      },
      {
        "action": "Design",
        "format": "stamp-sheet layout",
        "motifs": [
          "mushrooms",
          "moons",
          "little frames"
        ],
        "constraint": "Keep each stamp shape slightly different."
      },
      {
        "action": "Create",
        "format": "corner motif set",
        "motifs": [
          "bows",
          "berries",
          "leaves"
        ],
        "constraint": "Use one motif as a corner detail in two places."
      },
      {
        "action": "Design",
        "format": "alternating row repeat",
        "motifs": [
          "cats",
          "teacups",
          "stars"
        ],
        "constraint": "Alternate two motifs evenly."
      },
      {
        "action": "Design",
        "format": "negative-space repeat",
        "motifs": [
          "doves",
          "clouds",
          "branches"
        ],
        "constraint": "Let the empty spaces become part of the pattern."
      },
      {
        "action": "Create",
        "format": "tone-on-tone repeat",
        "motifs": [
          "pear slices",
          "leaves",
          "tiny dots"
        ],
        "constraint": "Keep the contrast intentionally subtle."
      },
      {
        "action": "Design",
        "format": "storybook border",
        "motifs": [
          "gnomes",
          "mushrooms",
          "lanterns"
        ],
        "constraint": "Build a border pattern instead of an all-over repeat."
      },
      {
        "action": "Create",
        "format": "coastal tossed repeat",
        "motifs": [
          "puffins",
          "shells",
          "stars"
        ],
        "constraint": "Scatter the motifs loosely instead of evenly."
      },
      {
        "action": "Design",
        "format": "cottagecore repeat",
        "motifs": [
          "strawberries",
          "ribbons",
          "wildflowers"
        ],
        "constraint": "Add one tiny filler mark throughout the pattern."
      },
      {
        "action": "Create",
        "format": "circus-inspired repeat",
        "motifs": [
          "circus tents",
          "stars",
          "puppets"
        ],
        "constraint": "Let one object tilt while the others stay straight."
      },
      {
        "action": "Design",
        "format": "fairytale repeat",
        "motifs": [
          "crowns",
          "frogs",
          "flowers"
        ],
        "constraint": "Repeat one motif in three sizes."
      },
      {
        "action": "Create",
        "format": "farmhouse repeat",
        "motifs": [
          "calves",
          "milk bottles",
          "sunflowers"
        ],
        "constraint": "Keep the spacing unusually open."
      },
      {
        "action": "Design",
        "format": "moonlit repeat",
        "motifs": [
          "moths",
          "moons",
          "ferns"
        ],
        "constraint": "Use one repeated shadow color across the whole piece."
      },
      {
        "action": "Create",
        "format": "heirloom motif set",
        "motifs": [
          "lockets",
          "flowers",
          "ribbons"
        ],
        "constraint": "Use one repeated label shape."
      },
      {
        "action": "Design",
        "format": "kaleidoscopic repeat",
        "motifs": [
          "butterflies",
          "stars",
          "leaves"
        ],
        "constraint": "Rotate the same motif in different directions."
      },
      {
        "action": "Create",
        "format": "tiny icon repeat",
        "motifs": [
          "cuckoo clocks",
          "keys",
          "flowers"
        ],
        "constraint": "Make one motif noticeably larger than the others."
      },
      {
        "action": "Design",
        "format": "diagonal stripe repeat",
        "motifs": [
          "pencils",
          "sparkles",
          "tiny birds"
        ],
        "constraint": "Repeat one motif in a straight line."
      },
      {
        "action": "Create",
        "format": "overlapping floral repeat",
        "motifs": [
          "poppies",
          "leaves",
          "berries"
        ],
        "constraint": "Let one object overlap another in each cluster."
      },
      {
        "action": "Design",
        "format": "ditzy repeat",
        "motifs": [
          "mini flowers",
          "tiny bows",
          "little stars"
        ],
        "constraint": "Keep the pattern very sparse."
      },
      {
        "action": "Create",
        "format": "harlequin repeat",
        "motifs": [
          "diamonds",
          "jester hats",
          "stars"
        ],
        "constraint": "Use one shape as a checker replacement."
      },
      {
        "action": "Design",
        "format": "apothecary label set",
        "motifs": [
          "herbs",
          "moons",
          "tiny bottles"
        ],
        "constraint": "Include one boxed-off section."
      },
      {
        "action": "Create",
        "format": "grandma-chic repeat",
        "motifs": [
          "teapots",
          "flowers",
          "lockets"
        ],
        "constraint": "Keep one motif facing the same direction every time."
      },
      {
        "action": "Design",
        "format": "grandpa-chic repeat",
        "motifs": [
          "record players",
          "stars",
          "little birds"
        ],
        "constraint": "Use one repeated pattern on two separate objects."
      },
      {
        "action": "Create",
        "format": "autumnal repeat",
        "motifs": [
          "acorns",
          "mushrooms",
          "crows"
        ],
        "constraint": "Add one filler motif between each larger motif."
      },
      {
        "action": "Design",
        "format": "sun-kissed repeat",
        "motifs": [
          "sunflowers",
          "bees",
          "little suns"
        ],
        "constraint": "Use the brightest palette color only once."
      },
      {
        "action": "Create",
        "format": "rainy-day repeat",
        "motifs": [
          "umbrellas",
          "puddles",
          "sparrows"
        ],
        "constraint": "Make the background a single palette color."
      },
      {
        "action": "Design",
        "format": "folkloric repeat",
        "motifs": [
          "hares",
          "moons",
          "branches"
        ],
        "constraint": "Keep the layout symmetrical but not stiff."
      },
      {
        "action": "Create",
        "format": "magical object repeat",
        "motifs": [
          "wands",
          "stars",
          "tiny books"
        ],
        "constraint": "Tuck one small item into an unexpected corner."
      },
      {
        "action": "Design",
        "format": "seaside border",
        "motifs": [
          "seagulls",
          "waves",
          "shells"
        ],
        "constraint": "Create a border around the outside edge."
      },
      {
        "action": "Create",
        "format": "bubbly repeat",
        "motifs": [
          "bubbles",
          "fish",
          "stars"
        ],
        "constraint": "Repeat one motif in three sizes."
      },
      {
        "action": "Design",
        "format": "puppet-theater repeat",
        "motifs": [
          "puppets",
          "curtains",
          "stars"
        ],
        "constraint": "Use one title area and one subtitle area."
      }
    ],
    "characterCreatures": [
      "pigeon",
      "snail",
      "bee",
      "butterfly",
      "frog",
      "rabbit",
      "fox",
      "owl",
      "hedgehog",
      "turtle",
      "cat",
      "dog",
      "duck",
      "mouse",
      "squirrel",
      "raccoon",
      "otter",
      "crab",
      "fish",
      "moth",
      "goose",
      "swan",
      "badger",
      "deer",
      "bear",
      "bat",
      "seal",
      "whale",
      "seahorse",
      "octopus",
      "jellyfish",
      "ladybug",
      "beetle",
      "dragonfly",
      "firefly",
      "caterpillar",
      "worm",
      "mole",
      "chipmunk",
      "sparrow",
      "robin",
      "crow",
      "pelican",
      "puffin",
      "sheep",
      "goat",
      "llama",
      "pony",
      "donkey",
      "chicken",
      "cow",
      "pig",
      "snake",
      "hare",
      "field mouse",
      "fawn",
      "black bear",
      "beaver",
      "possum",
      "skunk",
      "weasel",
      "ferret",
      "wolf",
      "coyote",
      "bobcat",
      "lynx",
      "songbird",
      "wren",
      "finch",
      "bluebird",
      "chickadee",
      "swallow",
      "dove",
      "raven",
      "magpie",
      "barn owl",
      "hawk",
      "heron",
      "egret",
      "crane",
      "seagull",
      "toad",
      "newt",
      "salamander",
      "slug",
      "bumblebee",
      "grasshopper",
      "cricket",
      "spider",
      "kitten",
      "puppy",
      "lamb",
      "calf",
      "horse",
      "piglet",
      "rooster",
      "hen",
      "chick",
      "turkey",
      "duckling",
      "gnome",
      "elf",
      "fairy",
      "sprite",
      "pixie",
      "mermaid",
      "sea witch",
      "selkie",
      "sea nymph",
      "water sprite",
      "unicorn",
      "narwhal"
    ],
    "characterRoles": [
      "postmaster",
      "librarian",
      "bookseller",
      "painter",
      "potter",
      "tailor",
      "florist",
      "baker",
      "tea host",
      "soup maker",
      "market vendor",
      "pastry chef",
      "chef",
      "gardener",
      "mapmaker",
      "photographer",
      "trail guide",
      "field guide",
      "forager",
      "birdwatcher",
      "shopkeeper",
      "pirate",
      "sailor",
      "fisherman",
      "clam digger",
      "beachcomber",
      "witch",
      "wizard",
      "magician",
      "fortune teller",
      "alchemist",
      "herbalist",
      "spellmaker",
      "princess",
      "prince",
      "queen",
      "king",
      "knight",
      "jester",
      "farmer",
      "shepherd",
      "milkman",
      "apothecary",
      "dancer",
      "nurse",
      "puppeteer",
      "acrobat",
      "fire dancer",
      "juggler"
    ],
    "characterRoleProps": {
      "postmaster": [
        "envelope bundle",
        "mail satchel",
        "postage stamp",
        "letter stack",
        "address book",
        "shelf sign"
      ],
      "librarian": [
        "book stack",
        "library card",
        "book cart",
        "reading glasses",
        "bookmark",
        "open book",
        "shelf sign",
        "catalog card"
      ],
      "bookseller": [
        "book stack",
        "reading glasses",
        "bookmark",
        "open book",
        "shelf sign",
        "catalog card"
      ],
      "painter": [
        "paint tube",
        "brush jar",
        "paint palette",
        "paintbrush",
        "color wheel",
        "paint cup",
        "sketchbook"
      ],
      "potter": [
        "clay pot",
        "apron",
        "pottery shelf",
        "turning tool",
        "basket"
      ],
      "tailor": [
        "pin cushion",
        "scissors",
        "measuring tape",
        "sewing basket"
      ],
      "florist": [
        "flower bucket",
        "bouquet wrap",
        "ribbon",
        "plant pot",
        "seed packet",
        "watering can",
        "price card",
        "vase",
        "flower cart"
      ],
      "baker": [
        "rolling pin",
        "pie",
        "cake slice",
        "croissant",
        "bread basket",
        "cake stand",
        "recipe card"
      ],
      "tea host": [
        "teapot",
        "tea tray",
        "mug",
        "cake slice",
        "teacup and saucer",
        "napkin"
      ],
      "soup maker": [
        "soup bowl",
        "spoon",
        "menu board",
        "napkin",
        "bread basket"
      ],
      "market vendor": [
        "basket",
        "display shelf",
        "price tag",
        "small sign",
        "wrapped package",
        "counter display",
        "receipt",
        "hanging sign",
        "product stack"
      ],
      "pastry chef": [
        "cake stand",
        "croissant",
        "cake slice",
        "recipe card"
      ],
      "chef": [
        "recipe card",
        "herb bundle"
      ],
      "gardener": [
        "watering can",
        "seed tray",
        "plant marker",
        "basket",
        "pruning shears",
        "garden gloves",
        "plant pot"
      ],
      "mapmaker": [
        "folded map",
        "compass",
        "pencil",
        "postcard"
      ],
      "photographer": [
        "camera",
        "binoculars",
        "postcard",
        "trail sign",
        "backpack"
      ],
      "trail guide": [
        "compass",
        "lantern",
        "binoculars",
        "backpack"
      ],
      "field guide": [
        "pencil",
        "binoculars",
        "postcard",
        "trail sign"
      ],
      "forager": [
        "basket",
        "pruning shears",
        "garden gloves",
        "mushroom",
        "plant marker"
      ],
      "birdwatcher": [
        "binoculars",
        "postcard",
        "trail sign",
        "backpack"
      ],
      "shopkeeper": [
        "basket",
        "display shelf",
        "price tag",
        "small sign",
        "wrapped package",
        "tool tray",
        "counter display",
        "receipt",
        "hanging sign",
        "product stack"
      ],
      "pirate": [
        "treasure map",
        "hat",
        "spyglass",
        "tiny flag"
      ],
      "sailor": [
        "sailboat",
        "rope",
        "striped shirt",
        "cap"
      ],
      "fisherman": [
        "fishing net",
        "bucket",
        "little boat",
        "hat"
      ],
      "clam digger": [
        "bucket",
        "shovel",
        "boots",
        "shell"
      ],
      "beachcomber": [
        "basket",
        "shell",
        "driftwood",
        "little map"
      ],
      "witch": [
        "broom",
        "spellbook",
        "moon charm",
        "potion bottle"
      ],
      "wizard": [
        "wand",
        "spellbook",
        "star chart",
        "cloak"
      ],
      "magician": [
        "top hat",
        "wand",
        "playing card",
        "cape"
      ],
      "fortune teller": [
        "crystal ball",
        "playing card",
        "moon charm",
        "table cloth"
      ],
      "alchemist": [
        "potion bottle",
        "star chart",
        "herb bundle",
        "little vial"
      ],
      "herbalist": [
        "herb bundle",
        "plant pot",
        "basket",
        "label"
      ],
      "spellmaker": [
        "spellbook",
        "potion bottle",
        "wand",
        "moon charm"
      ],
      "princess": [
        "crown",
        "ribbon",
        "little bouquet",
        "cape"
      ],
      "prince": [
        "crown",
        "cape",
        "little flag",
        "boots"
      ],
      "queen": [
        "crown",
        "cloak",
        "scepter",
        "brooch"
      ],
      "king": [
        "crown",
        "cloak",
        "scepter",
        "banner"
      ],
      "knight": [
        "shield",
        "banner",
        "boots",
        "helmet"
      ],
      "jester": [
        "hat",
        "bells",
        "playing card",
        "ribbon"
      ],
      "farmer": [
        "basket",
        "seed packet",
        "boots",
        "pitchfork"
      ],
      "shepherd": [
        "crook",
        "lamb",
        "cloak",
        "field flowers"
      ],
      "milkman": [
        "milk bottle",
        "delivery crate",
        "cap",
        "boots"
      ],
      "apothecary": [
        "potion bottle",
        "label",
        "herb bundle",
        "tiny jar"
      ],
      "dancer": [
        "ballet shoes",
        "ribbon",
        "stage curtain",
        "flower"
      ],
      "nurse": [
        "medical bag",
        "little cap",
        "bandage tin",
        "flower"
      ],
      "puppeteer": [
        "puppet",
        "stage curtain",
        "string bundle",
        "little sign"
      ],
      "acrobat": [
        "circus hoop",
        "ribbon",
        "stage curtain",
        "star"
      ],
      "fire dancer": [
        "torch",
        "ribbon",
        "stage curtain",
        "spark"
      ],
      "juggler": [
        "balls",
        "pins",
        "stage curtain",
        "hat"
      ]
    },
    "characterPreferredPairings": [
      {
        "creature": "pigeon",
        "role": "postmaster"
      },
      {
        "creature": "owl",
        "role": "librarian"
      },
      {
        "creature": "frog",
        "role": "florist"
      },
      {
        "creature": "frog",
        "role": "tea host"
      },
      {
        "creature": "fox",
        "role": "baker"
      },
      {
        "creature": "fox",
        "role": "bookseller"
      },
      {
        "creature": "mouse",
        "role": "bookseller"
      },
      {
        "creature": "mouse",
        "role": "tailor"
      },
      {
        "creature": "turtle",
        "role": "mapmaker"
      },
      {
        "creature": "turtle",
        "role": "tea host"
      },
      {
        "creature": "otter",
        "role": "photographer"
      },
      {
        "creature": "otter",
        "role": "potter"
      },
      {
        "creature": "crab",
        "role": "shopkeeper"
      },
      {
        "creature": "bat",
        "role": "bookseller"
      },
      {
        "creature": "mole",
        "role": "gardener"
      },
      {
        "creature": "butterfly",
        "role": "gardener"
      },
      {
        "creature": "fox",
        "role": "pirate"
      },
      {
        "creature": "raven",
        "role": "alchemist"
      },
      {
        "creature": "frog",
        "role": "apothecary"
      },
      {
        "creature": "moth",
        "role": "fortune teller"
      },
      {
        "creature": "owl",
        "role": "wizard"
      },
      {
        "creature": "rabbit",
        "role": "herbalist"
      },
      {
        "creature": "snail",
        "role": "beachcomber"
      },
      {
        "creature": "duck",
        "role": "sailor"
      },
      {
        "creature": "goose",
        "role": "milkman"
      },
      {
        "creature": "mouse",
        "role": "puppeteer"
      },
      {
        "creature": "cat",
        "role": "magician"
      },
      {
        "creature": "goat",
        "role": "farmer"
      },
      {
        "creature": "lamb",
        "role": "shepherd"
      },
      {
        "creature": "hedgehog",
        "role": "jester"
      },
      {
        "creature": "swan",
        "role": "dancer"
      },
      {
        "creature": "butterfly",
        "role": "fire dancer"
      },
      {
        "creature": "squirrel",
        "role": "juggler"
      },
      {
        "creature": "badger",
        "role": "knight"
      },
      {
        "creature": "deer",
        "role": "queen"
      },
      {
        "creature": "fawn",
        "role": "princess"
      },
      {
        "creature": "toad",
        "role": "witch"
      },
      {
        "creature": "crow",
        "role": "spellmaker"
      },
      {
        "creature": "otter",
        "role": "fisherman"
      },
      {
        "creature": "crab",
        "role": "clam digger"
      },
      {
        "creature": "seagull",
        "role": "sailor"
      },
      {
        "creature": "puffin",
        "role": "pirate"
      },
      {
        "creature": "chipmunk",
        "role": "farmer"
      },
      {
        "creature": "mole",
        "role": "apothecary"
      },
      {
        "creature": "barn owl",
        "role": "magician"
      },
      {
        "creature": "dove",
        "role": "dancer"
      },
      {
        "creature": "possum",
        "role": "beachcomber"
      },
      {
        "creature": "ferret",
        "role": "jester"
      },
      {
        "creature": "piglet",
        "role": "milkman"
      },
      {
        "creature": "calf",
        "role": "farmer"
      },
      {
        "creature": "sprite",
        "role": "herbalist"
      },
      {
        "creature": "pixie",
        "role": "fortune teller"
      },
      {
        "creature": "gnome",
        "role": "apothecary"
      },
      {
        "creature": "fairy",
        "role": "dancer"
      },
      {
        "creature": "mermaid",
        "role": "sailor"
      },
      {
        "creature": "sea witch",
        "role": "alchemist"
      }
    ],
    "characterExclusions": [
      {
        "creature": "whale",
        "role": "tailor"
      },
      {
        "creature": "jellyfish",
        "role": "baker"
      },
      {
        "creature": "jellyfish",
        "role": "tailor"
      },
      {
        "creature": "fish",
        "role": "baker"
      },
      {
        "creature": "seahorse",
        "role": "potter"
      },
      {
        "creature": "butterfly",
        "role": "potter"
      }
    ],
    "twists": [
      "Make one object much larger than the rest.",
      "Let one object overlap the edge of the composition.",
      "Keep everything inside a frame.",
      "Arrange everything in a circle.",
      "Arrange everything in a single row.",
      "Stack the main elements vertically.",
      "Build the composition around one central object.",
      "Tuck one small item into an unexpected corner.",
      "Leave one corner mostly empty.",
      "Fill the composition edge to edge.",
      "Use only three main shapes.",
      "Repeat one shape exactly three times.",
      "Make the smallest object the focal point.",
      "Use one object as the anchor and build around it.",
      "Keep the whole composition off-center.",
      "Place the main object low in the composition.",
      "Place the main object high in the composition.",
      "Create a border around the outside edge.",
      "Divide the composition into two clear sections.",
      "Fit everything inside a contained shape.",
      "Repeat one motif in three sizes.",
      "Turn one motif into a border element.",
      "Use the same shape in at least three different ways.",
      "Echo one curved line throughout the composition.",
      "Echo one pointed shape throughout the composition.",
      "Build the prompt mostly from rounded shapes.",
      "Build the prompt mostly from angular shapes.",
      "Add one repeating filler shape between larger elements.",
      "Use one shape as a connector between other elements.",
      "Turn one object into a simplified icon.",
      "Make one motif face two different directions.",
      "Mirror one shape somewhere else in the composition.",
      "Use one repeated pattern on two separate objects.",
      "Add one stripe shape in an unexpected place.",
      "Make one object from stacked shapes only.",
      "Break one large shape into smaller pieces.",
      "Turn one small motif into a larger hero shape.",
      "Hide one repeated shape in plain sight.",
      "Use one scallop shape somewhere in the design.",
      "Use one arch shape at least twice.",
      "Use the lightest palette color for the largest area.",
      "Save the darkest palette color for the smallest details.",
      "Use one palette color only for outlines.",
      "Let one palette color dominate the composition.",
      "Keep one palette color almost untouched.",
      "Use the brightest palette color only once.",
      "Use one palette color for every repeated shape.",
      "Make the background a single palette color.",
      "Use one palette color only on the focal point.",
      "Use the warmest palette color for the smallest object.",
      "Use the coolest palette color for shadows or secondary details.",
      "Keep all details in just two of the palette colors.",
      "Make one color carry all the filler elements.",
      "Use one palette color in a very unexpected place.",
      "Make two objects share the same color treatment.",
      "Keep the main subject mostly monochromatic.",
      "Add a simple repeat pattern to one object only.",
      "Use one pattern on a background shape.",
      "Keep the pattern larger than usual.",
      "Keep the pattern very sparse.",
      "Alternate two motifs evenly.",
      "Add one filler motif between each larger motif.",
      "Use one motif as the hero and one as the filler.",
      "Rotate the same motif in different directions.",
      "Keep the pattern readable from far away.",
      "Build a border pattern instead of an all-over repeat.",
      "Use one shape as a checker replacement.",
      "Turn one motif into a stamp-like repeat.",
      "Keep one motif facing the same direction every time.",
      "Scatter the motifs loosely instead of evenly.",
      "Keep the spacing unusually tight.",
      "Keep the spacing unusually open.",
      "Use one tiny filler mark throughout the pattern.",
      "Make one motif noticeably larger than the others.",
      "Repeat one motif in a straight line.",
      "Create a tossed layout with only three motif types.",
      "Give the character one prop that helps tell the story.",
      "Put the character in work mode.",
      "Put the character in rest mode.",
      "Add one accessory that feels a little overdressed.",
      "Make the pose feel very formal.",
      "Make the pose feel extra relaxed.",
      "Give the character a tiny uniform detail.",
      "Let one object the character holds become a focal point.",
      "Repeat one shape from the character in a nearby prop.",
      "Make the character look busy without adding a full scene.",
      "Add one practical tool the character would actually use.",
      "Let the character interact with one oversize object.",
      "Keep the expression simple and readable.",
      "Make the silhouette the most interesting part.",
      "Use one repeated pattern in the character’s clothing or accessories.",
      "Give the character one object to carry, balance, push, or pull.",
      "Add one hanging detail.",
      "Add one object on a shelf or ledge.",
      "Include one framed detail in the scene.",
      "Use one repeating textile pattern.",
      "Add one plant or botanical shape somewhere in the composition.",
      "Let one object cast a very obvious shadow shape.",
      "Keep the background simple and flat.",
      "Include one small object that suggests daily life.",
      "Add one patterned surface and keep the rest quiet.",
      "Use one window, doorway, or arch to contain the scene.",
      "Make the scene feel collected, not crowded.",
      "Add one soft object and one hard object.",
      "Tuck one item partly behind another.",
      "Include one tiny sign, label, or title area.",
      "Let one object hang, lean, or drape.",
      "Build the scene around one surface like a table, shelf, or sill.",
      "Include three related items and one odd one out.",
      "Add one title area and one subtitle area.",
      "Build the page around one hero panel.",
      "Keep one section much busier than the others.",
      "Use one repeated label shape.",
      "Add one icon or symbol that appears more than once.",
      "Create a clear top, middle, and bottom section.",
      "Use one border treatment throughout the page.",
      "Let one item break the grid slightly.",
      "Add one callout area.",
      "Repeat one decorative divider shape.",
      "Include one boxed-off section.",
      "Make one panel feel like a close-up.",
      "Keep one element oversized for emphasis.",
      "Use one tiny filler shape to unify the whole page.",
      "Include one object shown from a different angle than the rest.",
      "Use only side-view shapes.",
      "Use only front-facing shapes.",
      "Add one stitched edge somewhere unexpected.",
      "Give one object a scalloped outline.",
      "Let one object tilt while the others stay straight.",
      "Add one repeating dot cluster.",
      "Use one repeated shadow color across the whole piece.",
      "Make one object overlap a border.",
      "Use one motif as a corner detail in two places.",
      "Add one object that feels tucked away."
    ],
    "paletteConstraints": [
      "Use the lightest palette color for the largest area",
      "Save the darkest palette color for the smallest details",
      "Use one palette color only for outlines",
      "Make the background a single palette color",
      "Repeat one shape exactly three times",
      "Let one color show up only once",
      "Make one small detail the focal point",
      "Turn one repeated shape into a border",
      "Use the brightest palette color only once",
      "Keep all details in just two of the palette colors",
      "Make one color carry all the filler elements",
      "Use one palette color only on the focal point"
    ],
    "styleModifiers": {
      "handmade": [
        "painted",
        "hand-painted",
        "stamped",
        "block-printed",
        "paper-cut",
        "stitched",
        "carved",
        "collaged",
        "sketched",
        "inky",
        "textured",
        "speckled",
        "layered",
        "cut-paper",
        "linocut-inspired"
      ],
      "shape": [
        "scalloped",
        "arched",
        "symmetrical",
        "wonky",
        "ornate",
        "minimal",
        "chunky",
        "delicate",
        "bold",
        "rounded",
        "wavy",
        "tiled",
        "framed",
        "striped",
        "dotted",
        "checkered",
        "patchwork",
        "curvy",
        "leafy",
        "floral",
        "imperfect",
        "dainty",
        "lush",
        "overgrown",
        "sketchy"
      ],
      "vibe": [
        "folk",
        "storybook",
        "vintage-inspired",
        "decorative",
        "playful",
        "cozy",
        "botanical",
        "cottage-y",
        "storybook-ish",
        "whimsical",
        "cheerful",
        "charming",
        "nostalgic",
        "campy",
        "seaside",
        "pirate",
        "bubbly",
        "silly",
        "cutie-pie",
        "ethereal",
        "cosmic",
        "heirloom",
        "quirky",
        "rustic",
        "sweet",
        "sunny",
        "romantic",
        "old-fashioned",
        "fairytale",
        "magical",
        "cottagecore",
        "clowncore",
        "joyful",
        "coastal",
        "grandma-chic",
        "grandpa-chic",
        "autumnal",
        "kitschy",
        "farmhouse",
        "cottage",
        "well-loved",
        "folksy",
        "sprightly",
        "pastoral",
        "earthy",
        "dreamy",
        "antique",
        "sun-kissed",
        "foraged",
        "twinkly",
        "glowing",
        "starlit",
        "moonlit",
        "sunlit",
        "dewy",
        "rainy",
        "miniature",
        "childlike",
        "folkloric",
        "legendary",
        "theatrical",
        "eclectic",
        "maximal"
      ],
      "pattern": [
        "striped",
        "dotted",
        "checked",
        "gingham",
        "plaid",
        "scalloped",
        "speckled",
        "crosshatched",
        "tiled",
        "gridded",
        "terrazzo",
        "confetti-covered",
        "floral",
        "leafy",
        "starry",
        "stamped",
        "spotted",
        "polka-dotted",
        "pinstriped",
        "wide-striped",
        "wavy-striped",
        "zigzag",
        "chevron",
        "checkerboard",
        "diamond",
        "harlequin",
        "argyle",
        "diagonal-striped",
        "trailing",
        "ditzy",
        "mosaic",
        "paisley",
        "kaleidoscopic",
        "bordered",
        "scattered",
        "clustered",
        "alternating",
        "offset",
        "tossed",
        "symmetrical",
        "mirrored",
        "overlapping",
        "negative-space",
        "tone-on-tone"
      ]
    }
  }
};